import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  toEmailAddress2ffkb20dbp5nk as toEmailAddress,
  EmailAddress1n0o8cqqfp9qz as EmailAddress,
  toPhoneNumber24bmj59aego07 as toPhoneNumber,
  _PhoneNumber___init__impl__slwhzyo93bblbw66x0 as _PhoneNumber___init__impl__slwhzy,
} from '../../../../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import {
  elementAtOrNullh9s62cephf63 as elementAtOrNull,
  joinTo3lkanfaxbzac2 as joinTo,
  plus20p0vtfmu0596 as plus,
  minus1djrl64vbav3y as minus,
  distinct10qe1scfdvu5k as distinct,
  indexOfa2zokh3tu4p6 as indexOf,
  plus310ted5e4i90h as plus_0,
  sortedWith2csnbbb21k0lg as sortedWith,
  toList3jhuyej2anx2q as toList,
  withIndex37cl61h9v5txo as withIndex,
  getOrNull1go7ef9ldk0df as getOrNull,
  indexOf382xk9sq5x0r4 as indexOf_0,
  contains2gm06f5aa19ov as contains,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  get_issues1z1skb5sgeygq as get_issues,
  MutableValidated2ognu5vxf17ur as MutableValidated,
} from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
} from '../../components/nav/crowpay.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { GenericDialog2kroovzplfo3s as GenericDialog } from '../../dialogs/GenericDialog.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  contains3ue2qo8xhmpf1 as contains_0,
  isBlank1dvkhjjvox3p0 as isBlank,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  set_value1vvx5pkb20ebv as set_value,
  modify2eca96i8s7hc2 as modify,
  interceptWrite2xi6g5kl52xuu as interceptWrite,
  withWritedlio9p0oewet as withWrite,
} from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Contractor1wog4uk4l8u77 as Contractor,
  Owner3o3y53m8go5cb as Owner,
  Specification3fgfbf7ihgj8v as Specification,
  User8yb1tqk4kykg as User,
  License2dabzwgw7jcr2 as License,
  ContractorDocument2jcw9hqg98amj as ContractorDocument,
  Purpose_ProofOfEin_getInstance3u5kmocn55tdt as Purpose_ProofOfEin_getInstance,
  Purpose_ArticleOfIncorporation_getInstance1fuetuxvqqp0v as Purpose_ArticleOfIncorporation_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CreateOrEditOwner1qdnuxw2ttt7k as CreateOrEditOwner } from '../../dialogs/CreateOrEditOwner.mjs';
import {
  RegisterAccountSection_Bank_getInstance2xyzbaa4csj1z as RegisterAccountSection_Bank_getInstance,
  RegisterAccountSection_Register_getInstance1xr8dfta5nyc0 as RegisterAccountSection_Register_getInstance,
  RegisterAccountSection_Operations_getInstance1glc4bqrncfkk as RegisterAccountSection_Operations_getInstance,
  RegisterAccountSection_Profile_getInstance1312jyno6l78y as RegisterAccountSection_Profile_getInstance,
  RegisterAccountSection_Verification_getInstance1g2wlcm7n3sqb as RegisterAccountSection_Verification_getInstance,
  RegisterAccountSection_Owners_getInstance2yh7pxrqx85w6 as RegisterAccountSection_Owners_getInstance,
  RegisterAccountSection_Alerts_getInstance3g20s9j008qxo as RegisterAccountSection_Alerts_getInstance,
  RegisterAccountSection_Users_getInstancesmklt5otzrhb as RegisterAccountSection_Users_getInstance,
  RegisterAccountSection_Specs_getInstance1nrs0n7t69eza as RegisterAccountSection_Specs_getInstance,
  ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance,
} from '../common/ProjectView.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { ContractorDashboardpd20b7ol1l5h as ContractorDashboard } from '../contractor/ContractorDashboard.mjs';
import {
  coroutineScope284yy3flyb2v2 as coroutineScope,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  plus18eogev54fmsa as plus_1,
  plus1ogy4liedzq5j as plus_2,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { awaitNotNullzd1xp1uu2voc as awaitNotNull } from '../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import {
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
  get_session9cytjmfbg8nd as get_session,
} from '../../../sdk/UserSession.mjs';
import { pushChanges1lnw8bjwewvzf as pushChanges } from '../../../utils/Draft.ext.mjs';
import {
  ContractorStatus_Registering_getInstance9wzvdghru4x2 as ContractorStatus_Registering_getInstance,
  get_entriesyts36b0as1vz as get_entries,
  LicenseType_Contractor_getInstance2dtnrmu6zslm2 as LicenseType_Contractor_getInstance,
  LicenseType_Business_getInstance28mtgpzgwrkl8 as LicenseType_Business_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { get_selectedContractor2m4vxuqdzv6k3 as get_selectedContractor } from '../../../selectedContractor.mjs';
import {
  Addresscpovxna1tjmg as Address,
  OwnerStatus_Success_getInstancebzl48656m87y as OwnerStatus_Success_getInstance,
  DirectStatus_Failed_getInstance3unypatz9ynbl as DirectStatus_Failed_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  emptySetcxexqki71qfa as emptySet,
  setOf45ia9pnfhe90 as setOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOf1jh22dvmctj1r as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { isNotBlank2uco4vj45ytp1 as isNotBlank } from '../../../../../../crowpay-shared/com/crowpay/extensions/Address.ext.mjs';
import {
  Collection1k04j3hzsbod0 as Collection,
  KtSetjrjc7fhfd6b9 as KtSet,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { ServerFile1t91jzpzoixwe as ServerFile } from '../../../../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  InsetSemantic_getInstance3sydcrxjokdsg as InsetSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
  Semanticpmpmvt7fldq2 as Semantic,
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  listOfvhqybd2zx248 as listOf_0,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_textButtonybbt8y3eu5hx as get_textButton,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  get_deleteButton1v46c8rhktdg5 as get_deleteButton,
} from '../../theming/buttons.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from '../../dialogs/GenericConfirmationDialog.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  boldSubTitle1bjbn9bt8inbw as boldSubTitle,
  smallBody2trfy14zwtona as smallBody,
  bodyBold2czwdzwknab0k as bodyBold,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
} from '../../theming/Titles.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { notificationBar4efejtg2792g as notificationBar } from '../../theming/banners.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { dialog2nk0sz8wudj8p as dialog } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { Draftj5auffrm1u2b as Draft } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance,
  UUID21wrnrlmk5y1y as UUID,
} from '../../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Dimensions32ju1l7z4mh as Dimension,
  Companion_getInstance2v0f9t0g75gcs as Companion_getInstance_1,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  LateInitSignal30crwrg540xyy as LateInitSignal,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  arrayOf1akklvh2at202 as arrayOf,
  toString30pk9tzaqopn as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_contractor3k6krm423825t as get_contractor } from '../../../../../../crowpay-shared/com/crowpay/LicenseFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { get_contractor2z751sq639xj0 as get_contractor_0 } from '../../../../../../crowpay-shared/com/crowpay/ContractorDocumentFields.mjs';
import {
  branchij6ujhcuk22z as branch,
  assertValidEmail3vrj63qp73iex as assertValidEmail,
  assertValidPhoneNumber18rbry4lwjr66 as assertValidPhoneNumber,
  assertReactive1648n57bmw8d1 as assertReactive,
  assertNotBlankNamed365y7czhf0np3 as assertNotBlankNamed,
  validategsg6go7eyi9d as validate,
  validatecngbak7otryq as validate_0,
} from '../../../utils/validation.mjs';
import {
  get_contactFirstName4zsaw4v0liuh as get_contactFirstName,
  get_contactLastNamehzwltosy6qkq as get_contactLastName,
  get_contactEmail1hq0is5lnk4tx as get_contactEmail,
  get_contactPhoneNumberlh8nl8hy5d06 as get_contactPhoneNumber,
  get_name166ebenv7vstz as get_name,
  get_legalName1h459s03czxpi as get_legalName,
  get_email2a1pybafs9t2d as get_email,
  get_phoneNumber25jme78ksq49l as get_phoneNumber,
  get_contactAddress3g7cmdnh6wwi4 as get_contactAddress,
  get_operationStates3trs8asfalcha as get_operationStates,
  get_trade2rs99f111iqp6 as get_trade,
  get_annualRevenue2ut1l18ty4ija as get_annualRevenue,
  get_averageJobSizeaccwtlg964jf as get_averageJobSize,
  get_employeeCount270wmkrhxcm14 as get_employeeCount,
  get_otherBusinessData3m3w5ebpefc27 as get_otherBusinessData,
  get_entityTypelucy0bhwa1ig as get_entityType,
  get_addressidmncntp3o5q as get_address,
  get_ein66rl36efyxrr as get_ein,
  get_stateEntityNumber304fqw2g1kjna as get_stateEntityNumber,
  get_owners8roouuqxcbjh as get_owners,
} from '../../../../../../crowpay-shared/com/crowpay/ContractorFields.mjs';
import { lensPath16mstx1fbm6dz as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import {
  assertNotBlank3rcqh0n27fq5q as assertNotBlank,
  assertReactive30c64mz7ckt8m as assertReactive_0,
  assert3pektuc8qw5gc as assert,
  validate2pui9cukx7dk9 as validate_1,
  validateReactive3qltvv4cs75dh as validateReactive,
} from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { mutableRemember1h6fyyolumj0o as mutableRemember } from '../../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import { EditSpecifications2oyd85jvpdaul as EditSpecifications } from '../../components/specifications/EditSpecifications.mjs';
import { ScrollingBehaviorImpl35p8dxbs74spr as ScrollingBehaviorImpl } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ScrollView.commonHtml.js.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_2 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  get_compact3lsezez8nz8b6 as get_compact,
  dynamicThemexp3sdnaolntz as dynamicTheme,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem,
  get_dp28ag147e4p5cz as get_dp,
  get_rem14pbkv8p42gid as get_rem_0,
  Companion_getInstance33aui7uk8ap15 as Companion_getInstance_3,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atEnd1cw5d2zgug26 as get_atEnd,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
  get_empty2lwyggrwaqgos as get_empty,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  KProperty1ca4yb4wlo496 as KProperty1,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import {
  requiredField31yu7ndxhpyxkd as requiredField3,
  label287uhiq3m9m4z as label2,
  requiredLabel23q9lkacjaga4j as requiredLabel2,
  field321nct0g3w58o4 as field3,
} from '../../components/label2.mjs';
import { PhoneNumberInput1tdzv8kpf7vme as PhoneNumberInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/PhoneNumberInput.mjs';
import { RadioButton1rpamcjl5aybg as RadioButton } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RadioButton.commonHtml.mjs';
import { equalTo2dio0vrcsd3je as equalTo } from '../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { addressForm32k03uh8crpev as addressForm } from '../../components/addressForm.mjs';
import { multiselectp8aawqh86psn as multiselect } from '../../components/Multiselect.mjs';
import { renderLicenses2e5bww0s916bf as renderLicenses } from '../../components/files/contractorLicences.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import { NumberInput16nzuc28fuw7p as NumberInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/NumberField.commonHtml.mjs';
import { rangeTo5xinnemk0fd3 as rangeTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/Ranges.mjs';
import {
  zeroToNulldfpl77mwwdjq as zeroToNull,
  nullableToBlankejlkf60pbnzu as nullableToBlank,
  resize3py5p2yrjp6p7 as resize,
} from '../../../utils/utils.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { renderContractorDocuments200vd6dka4jio as renderContractorDocuments } from '../../components/files/contractorDocuments.mjs';
import { issueText2dqtp9rg036jt as issueText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import {
  lens27v59dqa1oc3r as lens,
  lens3m3nj3zkwtu6r as lens_0,
} from '../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  get_edit2tiiawv2658bs as get_edit,
  get_trash3qsdn4kaynjmu as get_trash,
} from '../../../icons.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../theming/separators.mjs';
import { ContractorBankInfo3chkr569ztcs7 as ContractorBankInfo } from '../contractor/ContractorBankInfo.mjs';
import { NotificationSubscriptionSettings19nypb7tkeyts as NotificationSubscriptionSettings } from '../common/NotificationSubscriptionSettings.mjs';
import { ManageContractorUsers27kb1m7q8tkdk as ManageContractorUsers } from '../contractor/ManageContractorUsers.mjs';
import { render38qn7o0b2bza2 as render } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import {
  IssueNode2x8c6ia7dmfdz as IssueNode,
  Warning3n5ye4cehejrw as Warning,
} from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/IssueNode.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { serializer1hwzc6m64v1op as serializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { PersistentProperty2s7ex88zm8bn9 as PersistentProperty } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/PersistentProperty.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { get_section1qyzr1npzel2z as get_section } from '../../theming/sections.mjs';
import { leftExpandButton23soimuuf6gel as leftExpandButton } from '../../components/expansion.mjs';
import {
  Indent_Section_getInstance2f8fy630t595n as Indent_Section_getInstance,
  indented3383b46h9g40w as indented,
} from '../../components/space.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { Companion_getInstancenv8qpb0wanrh as Companion_getInstance_4 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import { ForceConstant11m1vt5jr2l8f as ForceConstant } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/CornerRadii.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$Action, $completion) {
  var tmp = $this.jir_1.jit(VOID, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, spec, $completion) {
  var tmp = $this.kit_1.jit(VOID, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.lit_1.kir_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var c = tmp;
  var tmp_0;
  if (it == null) {
    tmp_0 = null;
  } else {
    var tmp2_firstName = c.e5j_1;
    var tmp3_lastName = c.f5j_1;
    var tmp4_email = toEmailAddress(c.g5j_1);
    var tmp5_phoneNumber = $this.lit_1.mit(c.h5j_1);
    var tmp6_address = c.i5j_1;
    tmp_0 = it.v88(VOID, tmp4_email, tmp5_phoneNumber, VOID, tmp2_firstName, tmp3_lastName, tmp6_address);
  }
  return tmp_0;
}
function *_generator_invoke__zhh2q8_2($this, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.nit_1.zir_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  return it.w5j(VOID, VOID, VOID, tmp$ret$0);
}
function *_generator_invoke__zhh2q8_3($this, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.oit_1.kir_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  return it.w5j(VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0.i5j_1);
}
function *_generator_invoke__zhh2q8_4($this, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.pit_1.kis_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.pit_1.qis_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  return it.w5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, tmp$ret$1);
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  var tmp = $this.qit_1.jit(VOID, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.qit_1.oir_1.iah(elementAtOrNull($this.qit_1.git_1, $this.rit_1 - 1 | 0), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_issues($this.sit_1.kir_1);
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!tmp.i1()) {
    $this.sit_1.iit_1.oam(true);
    var tmp_0 = get_dialogStack();
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_1 = StringBuilder().d1();
    // Inline function 'kotlin.text.appendLine' call
    var value = "There's some issues with your registration information.";
    // Inline function 'kotlin.text.appendLine' call
    this_1.wb(value).xb(_Char___init__impl__6a9atx(10));
    // Inline function 'kotlin.text.appendLine' call
    var value_0 = 'Note that required fields are marked with a red asterisk.';
    // Inline function 'kotlin.text.appendLine' call
    this_1.wb(value_0).xb(_Char___init__impl__6a9atx(10));
    // Inline function 'kotlin.text.appendLine' call
    this_1.xb(_Char___init__impl__6a9atx(10));
    // Inline function 'kotlin.text.appendLine' call
    var value_1 = 'Please fix the following issues and try again:';
    // Inline function 'kotlin.text.appendLine' call
    this_1.wb(value_1).xb(_Char___init__impl__6a9atx(10));
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_issues($this.sit_1.kir_1);
    var tmp_1 = await_0(this_2, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp_2 = tmp_1;
    joinTo(tmp_2, this_1, '\n \u2022 ', '\u2022 ', VOID, VOID, VOID, ContractorNewRegistrationData$navButtons$slambda$lambda);
    var tmp$ret$12 = this_1.toString();
    tmp_0.zgd(GenericDialog().dgh('Form Issues', tmp$ret$12));
    return Unit_instance;
  }
  $this.sit_1.iit_1.oam(false);
  var tmp_3 = $this.sit_1.vit($this.tit_1, $this.uit_1, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = $this.sit_1.oir_1.iah(null, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  return Unit_instance;
}
function ContractorNewRegistrationData$navButtons$slambda$lambda(it) {
  return it.s91();
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  var tmp = $this.wit_1.vit($this.xit_1, $this.yit_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.wit_1.oir_1.iah(elementAtOrNull($this.wit_1.git_1, $this.zit_1 + 1 | 0), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_8($this, query, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.aiu_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (contains_0(element.a4_1, query, true)) {
      destination.v(element);
    }
  }
  return destination;
}
function *_generator_invoke__zhh2q8_9($this, $this$interceptWrite, it, $completion) {
  if (it === 'Other') {
    set_value($this.biu_1.jis_1, true);
    var tmp = $this$interceptWrite.iah('', $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } else {
    set_value($this.biu_1.jis_1, false);
    var tmp_0 = $this$interceptWrite.iah(it, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_10($this, owner, $completion) {
  var tmp = modify($this.ciu_1.kir_1, ContractorNewRegistrationData$renderOwnerInformationForm$slambda$slambda$slambda_0(owner), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.ciu_1.jit(VOID, VOID, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var ContractorNewRegistrationData$renderOwnerInformationForm$slambda$slambda$slambdaClass;
function ContractorNewRegistrationData$renderOwnerInformationForm$slambda$slambda$slambda() {
  if (ContractorNewRegistrationData$renderOwnerInformationForm$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($owner) {
        this.diu_1 = $owner;
      }
      sip(it, $completion) {
        return it.w5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, plus(it.q5j_1, this.diu_1));
      }
      s2(p1, $completion) {
        return this.sip(p1 instanceof Contractor() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorNewRegistrationData$renderOwnerInformationForm$slambda$slambda$slambdaClass = $;
  }
  return ContractorNewRegistrationData$renderOwnerInformationForm$slambda$slambda$slambdaClass;
}
function ContractorNewRegistrationData$renderOwnerInformationForm$slambda$slambda$slambda_0($owner) {
  var i = new (ContractorNewRegistrationData$renderOwnerInformationForm$slambda$slambda$slambda())($owner);
  var l = (it, $completion) => i.sip(it, $completion);
  l.$arity = 1;
  return l;
}
var ContractorNewRegistrationData$renderOwnerInformationForm$slambda$slambdaClass;
function ContractorNewRegistrationData$renderOwnerInformationForm$slambda$slambda() {
  if (ContractorNewRegistrationData$renderOwnerInformationForm$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.ciu_1 = this$0;
      }
      mi9(owner, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this, owner), $completion);
      }
      s2(p1, $completion) {
        return this.mi9(p1 instanceof Owner() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorNewRegistrationData$renderOwnerInformationForm$slambda$slambdaClass = $;
  }
  return ContractorNewRegistrationData$renderOwnerInformationForm$slambda$slambdaClass;
}
function ContractorNewRegistrationData$renderOwnerInformationForm$slambda$slambda_0(this$0) {
  var i = new (ContractorNewRegistrationData$renderOwnerInformationForm$slambda$slambda())(this$0);
  var l = (owner, $completion) => i.mi9(owner, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_11($this, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.eiu_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  return it.w5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, plus(minus(it.q5j_1, tmp$ret$0), $this.fiu_1));
}
function *_generator_invoke__zhh2q8_12($this, updatedOwner, $completion) {
  var tmp = modify($this.giu_1.kir_1, ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda$slambda_0($this.hiu_1, updatedOwner), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.giu_1.jit(VOID, VOID, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda$slambdaClass;
function ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda$slambda() {
  if (ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($owner, $updatedOwner) {
        this.eiu_1 = $owner;
        this.fiu_1 = $updatedOwner;
      }
      sip(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.sip(p1 instanceof Contractor() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda$slambdaClass = $;
  }
  return ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda$slambdaClass;
}
function ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda$slambda_0($owner, $updatedOwner) {
  var i = new (ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda$slambda())($owner, $updatedOwner);
  var l = (it, $completion) => i.sip(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_13($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.iiu_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0;
  tmp.zgd(new (CreateOrEditOwner())(tmp_1, ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda_0($this.jiu_1, $this.iiu_1)));
  return Unit_instance;
}
var ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambdaClass;
function ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda() {
  if (ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $owner) {
        this.giu_1 = this$0;
        this.hiu_1 = $owner;
      }
      mi9(updatedOwner, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this, updatedOwner), $completion);
      }
      s2(p1, $completion) {
        return this.mi9(p1 instanceof Owner() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambdaClass = $;
  }
  return ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambdaClass;
}
function ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda_0(this$0, $owner) {
  var i = new (ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda())(this$0, $owner);
  var l = (updatedOwner, $completion) => i.mi9(updatedOwner, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_14($this, confirmed, $completion) {
  if (confirmed) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $this.kiu_1;
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var id = tmp.s6s_1;
    var tmp_0 = modify($this.liu_1.kir_1, ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda$slambda_2(id), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1 = $this.liu_1.jit(VOID, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  return Unit_instance;
}
var ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda$slambdaClass_0;
function ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda$slambda_1() {
  if (ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($id) {
        this.miu_1 = $id;
      }
      sip(c, $completion) {
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = c.q5j_1;
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (!element.s6s_1.equals(this.miu_1)) {
            destination.v(element);
          }
        }
        return c.w5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, destination);
      }
      s2(p1, $completion) {
        return this.sip(p1 instanceof Contractor() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda$slambdaClass_0 = $;
  }
  return ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda$slambdaClass_0;
}
function ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda$slambda_2($id) {
  var i = new (ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda$slambda_1())($id);
  var l = (c, $completion) => i.sip(c, $completion);
  l.$arity = 1;
  return l;
}
var ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambdaClass_0;
function ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda_1() {
  if (ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($owner, this$0) {
        this.kiu_1 = $owner;
        this.liu_1 = this$0;
      }
      egk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambdaClass_0 = $;
  }
  return ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambdaClass_0;
}
function ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda_2($owner, this$0) {
  var i = new (ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda_1())($owner, this$0);
  var l = (confirmed, $completion) => i.egk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_15($this, $completion) {
  var tmp = $this.niu_1.oir_1.iah(RegisterAccountSection_Bank_getInstance(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.oiu_1();
  return Unit_instance;
}
var ContractorNewRegistrationData$renderConnectBankForm$slambda$lambda$slambdaClass;
function ContractorNewRegistrationData$renderConnectBankForm$slambda$lambda$slambda() {
  if (ContractorNewRegistrationData$renderConnectBankForm$slambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $close) {
        this.niu_1 = this$0;
        this.oiu_1 = $close;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_15.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorNewRegistrationData$renderConnectBankForm$slambda$lambda$slambdaClass = $;
  }
  return ContractorNewRegistrationData$renderConnectBankForm$slambda$lambda$slambdaClass;
}
function ContractorNewRegistrationData$renderConnectBankForm$slambda$lambda$slambda_0(this$0, $close) {
  var i = new (ContractorNewRegistrationData$renderConnectBankForm$slambda$lambda$slambda())(this$0, $close);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ContractorNewRegistrationData$renderConnectBankForm$slambda$lambda$slambdaClass_0;
function ContractorNewRegistrationData$renderConnectBankForm$slambda$lambda$slambda_1() {
  if (ContractorNewRegistrationData$renderConnectBankForm$slambda$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$button, $close) {
        this.piu_1 = $$this$button;
        this.qiu_1 = $close;
      }
      uao($completion) {
        get_mainPageNavigator(this.piu_1).gbw(new (ContractorDashboard())());
        this.qiu_1();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorNewRegistrationData$renderConnectBankForm$slambda$lambda$slambdaClass_0 = $;
  }
  return ContractorNewRegistrationData$renderConnectBankForm$slambda$lambda$slambdaClass_0;
}
function ContractorNewRegistrationData$renderConnectBankForm$slambda$lambda$slambda_2($$this$button, $close) {
  var i = new (ContractorNewRegistrationData$renderConnectBankForm$slambda$lambda$slambda_1())($$this$button, $close);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_16($this, $completion) {
  var tmp = coroutineScope(ContractorNewRegistrationData$renderAlertsForm$slambda$slambda_0($this.riu_1, $this.siu_1, $this.tiu_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var ContractorNewRegistrationData$renderAlertsForm$slambda$slambdaClass;
function ContractorNewRegistrationData$renderAlertsForm$slambda$slambda() {
  if (ContractorNewRegistrationData$renderAlertsForm$slambda$slambdaClass === VOID) {
    class $ {
      constructor($settings, $viewed, this$0) {
        this.uiu_1 = $settings;
        this.viu_1 = $viewed;
        this.wiu_1 = this$0;
      }
      yah($this$coroutineScope, $completion) {
        this.uiu_1.jiv_1.zbe($this$coroutineScope);
        var _receiver__tnumb7 = this.viu_1;
        _receiver__tnumb7.oam(plus_1(_receiver__tnumb7.f2(), this.wiu_1.lir_1));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorNewRegistrationData$renderAlertsForm$slambda$slambdaClass = $;
  }
  return ContractorNewRegistrationData$renderAlertsForm$slambda$slambdaClass;
}
function ContractorNewRegistrationData$renderAlertsForm$slambda$slambda_0($settings, $viewed, this$0) {
  var i = new (ContractorNewRegistrationData$renderAlertsForm$slambda$slambda())($settings, $viewed, this$0);
  var l = ($this$coroutineScope, $completion) => i.yah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_17($this, $completion) {
  var tmp = coroutineScope(ContractorNewRegistrationData$renderUserAdminForm$slambda$slambda_0($this.kiv_1, $this.liv_1, $this.miv_1, $this.niv_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var ContractorNewRegistrationData$renderUserAdminForm$slambda$slambdaClass;
function ContractorNewRegistrationData$renderUserAdminForm$slambda$slambda() {
  if (ContractorNewRegistrationData$renderUserAdminForm$slambda$slambdaClass === VOID) {
    class $ {
      constructor($users, $$this$col, $viewed, this$0) {
        this.oiv_1 = $users;
        this.piv_1 = $$this$col;
        this.qiv_1 = $viewed;
        this.riv_1 = this$0;
      }
      yah($this$coroutineScope, $completion) {
        this.oiv_1.aiw(this.piv_1).zbe($this$coroutineScope);
        var _receiver__tnumb7 = this.qiv_1;
        _receiver__tnumb7.oam(plus_1(_receiver__tnumb7.f2(), this.riv_1.lir_1));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorNewRegistrationData$renderUserAdminForm$slambda$slambdaClass = $;
  }
  return ContractorNewRegistrationData$renderUserAdminForm$slambda$slambdaClass;
}
function ContractorNewRegistrationData$renderUserAdminForm$slambda$slambda_0($users, $$this$col, $viewed, this$0) {
  var i = new (ContractorNewRegistrationData$renderUserAdminForm$slambda$slambda())($users, $$this$col, $viewed, this$0);
  var l = ($this$coroutineScope, $completion) => i.yah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_retrievePaymentInfo__nex0l8($this, $completion) {
  var tmp = awaitNotNull($this.kir_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var c = tmp;
  var tmp_0 = awaitNotNull(get_rawSession(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.vfw().off_1.sfi(c.t5i_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var result = tmp_1;
  var tmp_2 = $this.cit_1.iah(result, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function *_generator_handleSave__a0jw65($this, request, onSave, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = modify($this.mir_1, ContractorNewRegistrationData$handleSave$slambda_0($this), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = $this.mir_1.bak($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var u = tmp_1;
  if (!(u == null)) {
    var tmp_2 = session.afw_1.geo(u.d88_1).iah(u, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.ais_1;
  var tmp_3 = await_0(this_1, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  if (tmp_3) {
    var tmp_4 = modify($this.kir_1, ContractorNewRegistrationData$handleSave$slambda_2($this), $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.ris_1;
  var tmp_5 = await_0(this_2, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  if (tmp_5) {
    var tmp_6 = modify($this.kir_1, ContractorNewRegistrationData$handleSave$slambda_4($this), $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
  }
  var tmp_7 = modify($this.kir_1, ContractorNewRegistrationData$handleSave$slambda_6($this), $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  var tmp_8 = pushChanges($this.kir_1, session.lfv_1, $completion);
  if (tmp_8 === get_COROUTINE_SUSPENDED())
    tmp_8 = yield tmp_8;
  var result = tmp_8;
  var tmp_9 = $this.kir_1.iah(result, $completion);
  if (tmp_9 === get_COROUTINE_SUSPENDED())
    tmp_9 = yield tmp_9;
  var tmp_10;
  if (request) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = $this.kir_1;
    var tmp_11 = await_0(this_3, $completion);
    if (tmp_11 === get_COROUTINE_SUSPENDED())
      tmp_11 = yield tmp_11;
    tmp_10 = tmp_11.r5j_1.equals(ContractorStatus_Registering_getInstance());
  } else {
    tmp_10 = false;
  }
  if (tmp_10) {
    var tmp_12 = session.vfw().off_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = $this.kir_1;
    var tmp_13 = await_0(this_4, $completion);
    if (tmp_13 === get_COROUTINE_SUSPENDED())
      tmp_13 = yield tmp_13;
    var tmp$ret$4 = tmp_13;
    var tmp_14 = tmp_12.mfi(tmp$ret$4.t5i_1, $completion);
    if (tmp_14 === get_COROUTINE_SUSPENDED())
      tmp_14 = yield tmp_14;
    var newContractor = tmp_14;
    var tmp_15 = (it) => it.t5i_1.equals(newContractor.t5i_1);
    session.lfv_1.eeo(tmp_15, (it) => newContractor);
    var tmp_16 = $this.kir_1.iah(newContractor, $completion);
    if (tmp_16 === get_COROUTINE_SUSPENDED())
      tmp_16 = yield tmp_16;
    var tmp_17 = $this.kir_1.bak($completion);
    if (tmp_17 === get_COROUTINE_SUSPENDED())
      tmp_17 = yield tmp_17;
  }
  if (onSave == null)
    null;
  else {
    var tmp_18 = onSave($completion);
    if (tmp_18 === get_COROUTINE_SUSPENDED())
      tmp_18 = yield tmp_18;
  }
  return Unit_instance;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.biw_1 = function_0;
      }
      wi(a, b) {
        return this.biw_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.biw_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function ContractorNewRegistrationData$contractor$lambda($this$Draft) {
  var tmp0_safe_receiver = $this$Draft.daj(get_selectedContractor());
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = $this$Draft.daj(get_rawSession());
    var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.lfv_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.geo(tmp0_safe_receiver);
    tmp = tmp2_safe_receiver == null ? null : $this$Draft.daj(tmp2_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    var tmp2_address = new (Address())();
    var tmp3_contactAddress = new (Address())();
    // Inline function 'kotlin.collections.setOf' call
    var tmp4_operationStates = emptySet();
    // Inline function 'kotlin.collections.listOf' call
    var tmp5_owners = emptyList();
    tmp_0 = new (Contractor())(VOID, VOID, '', '', '', '', tmp2_address, VOID, VOID, VOID, VOID, '', '', '', '', tmp3_contactAddress, tmp4_operationStates, 0, 0, 0, '', '', '', tmp5_owners);
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  return tmp_0;
}
function ContractorNewRegistrationData$user$lambda($this$Draft) {
  var tmp0_safe_receiver = $this$Draft.daj(get_rawSession());
  return tmp0_safe_receiver == null ? null : $this$Draft.daj(tmp0_safe_receiver.rfw_1);
}
var ContractorNewRegistrationData$submitForm$slambdaClass;
function ContractorNewRegistrationData$submitForm$slambda() {
  if (ContractorNewRegistrationData$submitForm$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.jir_1 = this$0;
      }
      yah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorNewRegistrationData$submitForm$slambdaClass = $;
  }
  return ContractorNewRegistrationData$submitForm$slambdaClass;
}
function ContractorNewRegistrationData$submitForm$slambda_0(this$0) {
  var i = new (ContractorNewRegistrationData$submitForm$slambda())(this$0);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function ContractorNewRegistrationData$_trades$lambda($this$remember) {
  return $this$remember.daj(get_session()).xfv_1.heo(new (Query())(VOID, VOID, VOID, 2147483647));
}
function ContractorNewRegistrationData$businessContactAddress$lambda(it) {
  return isNotBlank(it);
}
function ContractorNewRegistrationData$businessStates$lambda(it) {
  // Inline function 'kotlin.collections.isNotEmpty' call
  return !it.i1();
}
function ContractorNewRegistrationData$trade$lambda(it) {
  return it == null ? 'Unselected' : it;
}
function ContractorNewRegistrationData$trade$lambda_0(it) {
  switch (it) {
    case '':
    case 'Other':
    case 'Unselected':
      return null;
    default:
      return it;
  }
}
function ContractorNewRegistrationData$trade$lambda_1(it) {
  return isBlank(it) ? 'Cannot be blank' : it === 'Other' || it === 'Unselected' ? 'Must have a selected trade' : it.length < 3 ? 'Trade must be at least 3 characters' : null;
}
function ContractorNewRegistrationData$approxAnnualRevenue$lambda(it) {
  return !(it == null) && it > 0;
}
function ContractorNewRegistrationData$type$lambda(it) {
  return it == null ? 'Unselected' : it;
}
function ContractorNewRegistrationData$type$lambda_0(it) {
  return it === 'Unselected' ? null : it;
}
function ContractorNewRegistrationData$type$lambda_1(it) {
  return !(it === 'Unselected');
}
function ContractorNewRegistrationData$owners$lambda(it) {
  // Inline function 'kotlin.collections.isNotEmpty' call
  return !it.i1();
}
function ContractorNewRegistrationData$owners$lambda_0(o) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(o, Collection())) {
      tmp = o.i1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = o.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp_0 = element.d6t_1;
      if (!((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null)) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
function ContractorNewRegistrationData$owners$lambda_1(o) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(o, 10));
  var _iterator__ex2g4s = o.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = new (EmailAddress())(item.v6s_1);
    destination.v(tmp$ret$0);
  }
  // Inline function 'kotlin.let' call
  return distinct(destination).p1() === destination.p1();
}
var ContractorNewRegistrationData$editSpecifications$slambdaClass;
function ContractorNewRegistrationData$editSpecifications$slambda() {
  if (ContractorNewRegistrationData$editSpecifications$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.kit_1 = this$0;
      }
      ki2(spec, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, spec), $completion);
      }
      s2(p1, $completion) {
        return this.ki2(p1 instanceof Specification() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorNewRegistrationData$editSpecifications$slambdaClass = $;
  }
  return ContractorNewRegistrationData$editSpecifications$slambdaClass;
}
function ContractorNewRegistrationData$editSpecifications$slambda_0(this$0) {
  var i = new (ContractorNewRegistrationData$editSpecifications$slambda())(this$0);
  var l = (spec, $completion) => i.ki2(spec, $completion);
  l.$arity = 1;
  return l;
}
function ContractorNewRegistrationData$renderStatusDisplay$lambda($steps, this$0, $idx, $pair) {
  return ($this$dynamicTheme) => {
    var tmp;
    var tmp_0;
    if (indexOf($steps, $this$dynamicTheme.daj(this$0.oir_1)) >= $idx) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_0 = !$this$dynamicTheme.daj(get_issues($pair.f2())).i1();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = InProgressSemantic_getInstance();
    } else {
      var tmp_1;
      if (!$pair.e2().equals($this$dynamicTheme.daj(this$0.oir_1))) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_1 = !$this$dynamicTheme.daj(get_issues($pair.f2())).i1();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp = UnstartedSemantic_getInstance();
      } else {
        tmp = CompletedSemantic_getInstance();
      }
    }
    return tmp.abf(InsetSemantic_getInstance());
  };
}
function ContractorNewRegistrationData$renderStatusDisplay$lambda_0($steps, this$0, $idx, $next) {
  return ($this$dynamicTheme) => {
    var tmp;
    var tmp_0;
    if (indexOf($steps, $this$dynamicTheme.daj(this$0.oir_1)) >= ($idx + 1 | 0)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_0 = !$this$dynamicTheme.daj(get_issues($next.f2())).i1();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = InProgressSemantic_getInstance();
    } else {
      var tmp_1;
      if (!$next.e2().equals($this$dynamicTheme.daj(this$0.oir_1))) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_1 = !$this$dynamicTheme.daj(get_issues($next.f2())).i1();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp = UnstartedSemantic_getInstance();
      } else {
        tmp = CompletedSemantic_getInstance();
      }
    }
    return tmp.abf(InsetSemantic_getInstance());
  };
}
function ContractorNewRegistrationData$renderStatusDisplay$lambda_1($pair, this$0) {
  return ($this$shownWhen) => {
    var tmp;
    if (!$pair.e2().equals($this$shownWhen.daj(this$0.oir_1))) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !$this$shownWhen.daj(get_issues($pair.f2())).i1();
    } else {
      tmp = false;
    }
    return tmp;
  };
}
function ContractorNewRegistrationData$renderStatusDisplay$lambda_2($pair, this$0) {
  return ($this$shownWhen) => {
    var tmp;
    if ($pair.e2().equals($this$shownWhen.daj(this$0.oir_1))) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !$this$shownWhen.daj(get_issues($pair.f2())).i1();
    } else {
      tmp = false;
    }
    return tmp;
  };
}
function ContractorNewRegistrationData$renderStatusDisplay$lambda_3($pair) {
  return ($this$shownWhen) => $this$shownWhen.daj(get_issues($pair.f2())).i1();
}
var ContractorNewRegistrationData$handleSave$slambdaClass;
function ContractorNewRegistrationData$handleSave$slambda() {
  if (ContractorNewRegistrationData$handleSave$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.lit_1 = this$0;
      }
      ciw(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.ciw((p1 == null ? true : p1 instanceof User()) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorNewRegistrationData$handleSave$slambdaClass = $;
  }
  return ContractorNewRegistrationData$handleSave$slambdaClass;
}
function ContractorNewRegistrationData$handleSave$slambda_0(this$0) {
  var i = new (ContractorNewRegistrationData$handleSave$slambda())(this$0);
  var l = (it, $completion) => i.ciw(it, $completion);
  l.$arity = 1;
  return l;
}
var ContractorNewRegistrationData$handleSave$slambdaClass_0;
function ContractorNewRegistrationData$handleSave$slambda_1() {
  if (ContractorNewRegistrationData$handleSave$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.nit_1 = this$0;
      }
      sip(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.sip(p1 instanceof Contractor() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorNewRegistrationData$handleSave$slambdaClass_0 = $;
  }
  return ContractorNewRegistrationData$handleSave$slambdaClass_0;
}
function ContractorNewRegistrationData$handleSave$slambda_2(this$0) {
  var i = new (ContractorNewRegistrationData$handleSave$slambda_1())(this$0);
  var l = (it, $completion) => i.sip(it, $completion);
  l.$arity = 1;
  return l;
}
var ContractorNewRegistrationData$handleSave$slambdaClass_1;
function ContractorNewRegistrationData$handleSave$slambda_3() {
  if (ContractorNewRegistrationData$handleSave$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.oit_1 = this$0;
      }
      sip(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.sip(p1 instanceof Contractor() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorNewRegistrationData$handleSave$slambdaClass_1 = $;
  }
  return ContractorNewRegistrationData$handleSave$slambdaClass_1;
}
function ContractorNewRegistrationData$handleSave$slambda_4(this$0) {
  var i = new (ContractorNewRegistrationData$handleSave$slambda_3())(this$0);
  var l = (it, $completion) => i.sip(it, $completion);
  l.$arity = 1;
  return l;
}
var ContractorNewRegistrationData$handleSave$slambdaClass_2;
function ContractorNewRegistrationData$handleSave$slambda_5() {
  if (ContractorNewRegistrationData$handleSave$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0) {
        this.pit_1 = this$0;
      }
      sip(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.sip(p1 instanceof Contractor() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorNewRegistrationData$handleSave$slambdaClass_2 = $;
  }
  return ContractorNewRegistrationData$handleSave$slambdaClass_2;
}
function ContractorNewRegistrationData$handleSave$slambda_6(this$0) {
  var i = new (ContractorNewRegistrationData$handleSave$slambda_5())(this$0);
  var l = (it, $completion) => i.sip(it, $completion);
  l.$arity = 1;
  return l;
}
function Button$_get_visible_$ref_mav0jg(p0) {
  return () => p0.ab9();
}
function Button$_set_visible_$ref_7zj5sg(p0) {
  return (_this__u8e3s4) => {
    p0.zb8(_this__u8e3s4);
    return Unit_instance;
  };
}
var ContractorNewRegistrationData$navButtons$slambdaClass;
function ContractorNewRegistrationData$navButtons$slambda() {
  if (ContractorNewRegistrationData$navButtons$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $index) {
        this.qit_1 = this$0;
        this.rit_1 = $index;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorNewRegistrationData$navButtons$slambdaClass = $;
  }
  return ContractorNewRegistrationData$navButtons$slambdaClass;
}
function ContractorNewRegistrationData$navButtons$slambda_0(this$0, $index) {
  var i = new (ContractorNewRegistrationData$navButtons$slambda())(this$0, $index);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ContractorNewRegistrationData$navButtons$slambdaClass_0;
function ContractorNewRegistrationData$navButtons$slambda_1() {
  if (ContractorNewRegistrationData$navButtons$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $requestReview, $onSave) {
        this.sit_1 = this$0;
        this.tit_1 = $requestReview;
        this.uit_1 = $onSave;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorNewRegistrationData$navButtons$slambdaClass_0 = $;
  }
  return ContractorNewRegistrationData$navButtons$slambdaClass_0;
}
function ContractorNewRegistrationData$navButtons$slambda_2(this$0, $requestReview, $onSave) {
  var i = new (ContractorNewRegistrationData$navButtons$slambda_1())(this$0, $requestReview, $onSave);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ContractorNewRegistrationData$navButtons$slambdaClass_1;
function ContractorNewRegistrationData$navButtons$slambda_3() {
  if (ContractorNewRegistrationData$navButtons$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0, $requestReview, $onSave, $index) {
        this.wit_1 = this$0;
        this.xit_1 = $requestReview;
        this.yit_1 = $onSave;
        this.zit_1 = $index;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorNewRegistrationData$navButtons$slambdaClass_1 = $;
  }
  return ContractorNewRegistrationData$navButtons$slambdaClass_1;
}
function ContractorNewRegistrationData$navButtons$slambda_4(this$0, $requestReview, $onSave, $index) {
  var i = new (ContractorNewRegistrationData$navButtons$slambda_3())(this$0, $requestReview, $onSave, $index);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function ContractorNewRegistrationData$renderBusinessOpsForm$lambda$lambda($this$remember) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_entries();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    destination.v(item);
  }
  return destination;
}
var ContractorNewRegistrationData$renderBusinessOpsForm$lambda$slambdaClass;
function ContractorNewRegistrationData$renderBusinessOpsForm$lambda$slambda() {
  if (ContractorNewRegistrationData$renderBusinessOpsForm$lambda$slambdaClass === VOID) {
    class $ {
      constructor($states) {
        this.aiu_1 = $states;
      }
      wg8(query, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this, query), $completion);
      }
      s2(p1, $completion) {
        return this.wg8((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorNewRegistrationData$renderBusinessOpsForm$lambda$slambdaClass = $;
  }
  return ContractorNewRegistrationData$renderBusinessOpsForm$lambda$slambdaClass;
}
function ContractorNewRegistrationData$renderBusinessOpsForm$lambda$slambda_0($states) {
  var i = new (ContractorNewRegistrationData$renderBusinessOpsForm$lambda$slambda())($states);
  var l = (query, $completion) => i.wg8(query, $completion);
  l.$arity = 1;
  return l;
}
function ContractorNewRegistrationData$renderBusinessOpsForm$lambda$lambda_0(it) {
  return it;
}
function ContractorNewRegistrationData$renderBusinessOpsForm$lambda$lambda_1(it) {
  return it.a4_1;
}
var ContractorNewRegistrationData$renderBusinessProfileForm$lambda$slambdaClass;
function ContractorNewRegistrationData$renderBusinessProfileForm$lambda$slambda() {
  if (ContractorNewRegistrationData$renderBusinessProfileForm$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.biu_1 = this$0;
      }
      diw($this$interceptWrite, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this, $this$interceptWrite, it), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, MutableValidated()) : false) ? p1 : THROW_CCE();
        return this.diw(tmp, (!(p2 == null) ? typeof p2 === 'string' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ContractorNewRegistrationData$renderBusinessProfileForm$lambda$slambdaClass = $;
  }
  return ContractorNewRegistrationData$renderBusinessProfileForm$lambda$slambdaClass;
}
function ContractorNewRegistrationData$renderBusinessProfileForm$lambda$slambda_0(this$0) {
  var i = new (ContractorNewRegistrationData$renderBusinessProfileForm$lambda$slambda())(this$0);
  var l = ($this$interceptWrite, it, $completion) => i.diw($this$interceptWrite, it, $completion);
  l.$arity = 2;
  return l;
}
function ContractorNewRegistrationData$renderBusinessProfileForm$lambda$lambda(it) {
  return it;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function ContractorNewRegistrationData$renderBusinessVerificationForm$lambda$lambda($this$remember) {
  var tmp = listOf_0('Unselected');
  // Inline function 'kotlin.collections.map' call
  var this_0 = $this$remember.daj($this$remember.daj(get_session()).yfv_1.heo(new (Query())(VOID, VOID, VOID, 2147483647)));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = item.l5z_1;
    destination.v(tmp$ret$0);
  }
  return plus_0(tmp, destination);
}
function ContractorNewRegistrationData$renderBusinessVerificationForm$lambda$lambda_0(it) {
  return it;
}
function Issue$_get_description_$ref_ujb3fr() {
  return (p0) => p0.s91();
}
var ContractorNewRegistrationData$renderOwnerInformationForm$slambdaClass;
function ContractorNewRegistrationData$renderOwnerInformationForm$slambda() {
  if (ContractorNewRegistrationData$renderOwnerInformationForm$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.eiw_1 = this$0;
      }
      uao($completion) {
        var tmp = get_dialogStack();
        tmp.zgd(new (CreateOrEditOwner())(null, ContractorNewRegistrationData$renderOwnerInformationForm$slambda$slambda_0(this.eiw_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorNewRegistrationData$renderOwnerInformationForm$slambdaClass = $;
  }
  return ContractorNewRegistrationData$renderOwnerInformationForm$slambdaClass;
}
function ContractorNewRegistrationData$renderOwnerInformationForm$slambda_0(this$0) {
  var i = new (ContractorNewRegistrationData$renderOwnerInformationForm$slambda())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function ContractorNewRegistrationData$renderOwnerInformationForm$lambda(l) {
  // Inline function 'kotlin.collections.sortedByDescending' call
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp = ContractorNewRegistrationData$renderOwnerInformationForm$lambda$lambda;
  var tmp$ret$0 = new (sam$kotlin_Comparator$0())(tmp);
  return sortedWith(l, tmp$ret$0);
}
function ContractorNewRegistrationData$renderOwnerInformationForm$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.b6t_1;
  var tmp$ret$1 = a.b6t_1;
  return compareValues(tmp, tmp$ret$1);
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambdaClass;
function ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda() {
  if (ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambdaClass === VOID) {
    class $ {
      constructor($owner, this$0) {
        this.iiu_1 = $owner;
        this.jiu_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambdaClass = $;
  }
  return ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambdaClass;
}
function ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda_0($owner, this$0) {
  var i = new (ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda())($owner, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambdaClass_0;
function ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda_1() {
  if (ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($owner, this$0) {
        this.fiw_1 = $owner;
        this.giw_1 = this$0;
      }
      uao($completion) {
        var tmp = get_dialogStack();
        var tmp_0 = DangerButtonSemantic_getInstance();
        tmp.zgd(new (GenericConfirmationDialog())('Delete Owner?', 'You are about to remove this owner form the list. Deleted owners cannot be recovered. Delete this Owner?', VOID, 'Delete Owner', VOID, tmp_0, VOID, VOID, VOID, VOID, ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda$slambda_2(this.fiw_1, this.giw_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambdaClass_0 = $;
  }
  return ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambdaClass_0;
}
function ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda_2($owner, this$0) {
  var i = new (ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda_1())($owner, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ContractorNewRegistrationData$renderConnectBankForm$slambdaClass;
function ContractorNewRegistrationData$renderConnectBankForm$slambda() {
  if (ContractorNewRegistrationData$renderConnectBankForm$slambdaClass === VOID) {
    class $ {
      constructor($$this$col, this$0) {
        this.hiw_1 = $$this$col;
        this.iiw_1 = this$0;
      }
      uao($completion) {
        dialog(this.hiw_1, VOID, ($this$dialog, close) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$dialog.pc());
          var tmp0_elvis_lhs = $this$dialog.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$dialog : tmp0_elvis_lhs;
          $this$dialog.gbb(p, view);
          view.zbm(true);
          view.bb9(get_AppDimensions().bg2_1);
          title(view, 'Registration Completed!');
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.zbm(true);
          view_0.lbb(notificationBar(view_0, AppColors_getInstance().lfz_1), body(view_0, 'You have successfully submitted your registration information to Stoze. We will review your information and notify you when it gets approved. \nUntil then, feel free to explore the app and familiarize yourself its features. If you want, you can continue setting up your account below.'));
          view_0.lbb(notificationBar(view_0, AppColors_getInstance().kfz_1), body(view_0, 'Note that until your information is approved by an Admin you will have limited access to certain parts of the app, such as creating projects.'));
          view.hbb(p_0, view_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_1 = view.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
          view.gbb(p_1, view_1);
          view_1.zbm(false);
          var tmp = get_primaryButton(view_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (Button())(view_1.pc());
          var tmp0_elvis_lhs_2 = view_1.ebb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
          view_1.gbb(p_2, view_2);
          specCenteredText(view_2, 'Continue Setup');
          onClick(view_2, VOID, VOID, ContractorNewRegistrationData$renderConnectBankForm$slambda$lambda$slambda_0(this.iiw_1, close));
          view_1.hbb(p_2, view_2);
          view_1.lbb(tmp, view_2);
          var tmp_0 = get_textButton(view_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (Button())(view_1.pc());
          var tmp0_elvis_lhs_3 = view_1.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
          view_1.gbb(p_3, view_3);
          specCenteredText(view_3, 'Go Home');
          onClick(view_3, 'Leave and go to dashboard', VOID, ContractorNewRegistrationData$renderConnectBankForm$slambda$lambda$slambda_2(view_3, close));
          view_1.hbb(p_3, view_3);
          view_1.lbb(tmp_0, view_3);
          view.hbb(p_1, view_1);
          $this$dialog.hbb(p, view);
          return Unit_instance;
        });
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorNewRegistrationData$renderConnectBankForm$slambdaClass = $;
  }
  return ContractorNewRegistrationData$renderConnectBankForm$slambdaClass;
}
function ContractorNewRegistrationData$renderConnectBankForm$slambda_0($$this$col, this$0) {
  var i = new (ContractorNewRegistrationData$renderConnectBankForm$slambda())($$this$col, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ContractorNewRegistrationData$renderAlertsForm$slambdaClass;
function ContractorNewRegistrationData$renderAlertsForm$slambda() {
  if (ContractorNewRegistrationData$renderAlertsForm$slambdaClass === VOID) {
    class $ {
      constructor($settings, $viewed, this$0) {
        this.riu_1 = $settings;
        this.siu_1 = $viewed;
        this.tiu_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_16.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorNewRegistrationData$renderAlertsForm$slambdaClass = $;
  }
  return ContractorNewRegistrationData$renderAlertsForm$slambdaClass;
}
function ContractorNewRegistrationData$renderAlertsForm$slambda_0($settings, $viewed, this$0) {
  var i = new (ContractorNewRegistrationData$renderAlertsForm$slambda())($settings, $viewed, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ContractorNewRegistrationData$renderUserAdminForm$slambdaClass;
function ContractorNewRegistrationData$renderUserAdminForm$slambda() {
  if (ContractorNewRegistrationData$renderUserAdminForm$slambdaClass === VOID) {
    class $ {
      constructor($users, $$this$col, $viewed, this$0) {
        this.kiv_1 = $users;
        this.liv_1 = $$this$col;
        this.miv_1 = $viewed;
        this.niv_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_17.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorNewRegistrationData$renderUserAdminForm$slambdaClass = $;
  }
  return ContractorNewRegistrationData$renderUserAdminForm$slambdaClass;
}
function ContractorNewRegistrationData$renderUserAdminForm$slambda_0($users, $$this$col, $viewed, this$0) {
  var i = new (ContractorNewRegistrationData$renderUserAdminForm$slambda())($users, $$this$col, $viewed, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ContractorNewRegistrationData$renderAccountSpecificationsForm$slambdaClass;
function ContractorNewRegistrationData$renderAccountSpecificationsForm$slambda() {
  if (ContractorNewRegistrationData$renderAccountSpecificationsForm$slambdaClass === VOID) {
    class $ {
      constructor($viewed, this$0, $$this$col) {
        this.jiw_1 = $viewed;
        this.kiw_1 = this$0;
        this.liw_1 = $$this$col;
      }
      uao($completion) {
        var _receiver__tnumb7 = this.jiw_1;
        _receiver__tnumb7.oam(plus_1(_receiver__tnumb7.f2(), this.kiw_1.lir_1));
        get_mainPageNavigator(this.liw_1).fbw(new (ContractorDashboard())());
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorNewRegistrationData$renderAccountSpecificationsForm$slambdaClass = $;
  }
  return ContractorNewRegistrationData$renderAccountSpecificationsForm$slambdaClass;
}
function ContractorNewRegistrationData$renderAccountSpecificationsForm$slambda_0($viewed, this$0, $$this$col) {
  var i = new (ContractorNewRegistrationData$renderAccountSpecificationsForm$slambda())($viewed, this$0, $$this$col);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ContractorNewRegistrationDataClass;
function ContractorNewRegistrationData() {
  if (ContractorNewRegistrationDataClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        tmp.kir_1 = validated(Draft(ContractorNewRegistrationData$contractor$lambda));
        var tmp_0 = this;
        var tmp0_elvis_lhs = get_selectedContractor().f2();
        tmp_0.lir_1 = tmp0_elvis_lhs == null ? Companion_getInstance().k2p() : tmp0_elvis_lhs;
        var tmp_1 = this;
        tmp_1.mir_1 = Draft(ContractorNewRegistrationData$user$lambda);
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_0().ecg_1;
        tmp_2.nir_1 = Action('Save', tmp_3, VOID, VOID, VOID, VOID, ContractorNewRegistrationData$submitForm$slambda_0(this));
        this.oir_1 = Signal().hak(null);
        var tmp_4 = this;
        tmp_4.pir_1 = remember(VOID, VOID, VOID, ContractorNewRegistrationData$_trades$lambda);
        var tmp_5 = this;
        tmp_5.qir_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = listOf(['Unselected', 'Other']);
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.daj($this$remember.daj(this.pir_1));
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp$ret$0 = item.c86_1;
            destination.v(tmp$ret$0);
          }
          return plus_0(tmp, destination);
        });
        var tmp_6 = this;
        tmp_6.rir_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).nfv_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(License()), arrayOf([]), false));
          var tmp$ret$4 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$4);
          var tmp$ret$6 = eq(get_contractor(it), $this$remember.daj(this.kir_1).t5i_1);
          var tmp$ret$7 = new (Query())(tmp$ret$6, orderBy, 0, 100);
          return tmp.heo(tmp$ret$7);
        });
        var tmp_7 = this;
        tmp_7.sir_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).mfv_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ContractorDocument()), arrayOf([]), false));
          var tmp$ret$9 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$9);
          var tmp$ret$11 = eq(get_contractor_0(it), $this$remember.gaj(this.kir_1).t5i_1);
          var tmp$ret$12 = new (Query())(tmp$ret$11, orderBy, 0, 100);
          return tmp.mdw(tmp$ret$12);
        });
        this.tir_1 = branch(this.kir_1);
        var tmp_8 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_0 = this.tir_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_9 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$13 = isInterface(tmp_9, KSerializer()) ? tmp_9 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$13);
        var tmp$ret$15 = get_contactFirstName(it);
        var tmp$ret$16 = lensPath(this_0, tmp$ret$15);
        tmp_8.uir_1 = assertNotBlank(tmp$ret$16);
        var tmp_10 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_1 = this.tir_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_11 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$17 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
        var it_0 = new (DataClassPathSelf())(tmp$ret$17);
        var tmp$ret$19 = get_contactLastName(it_0);
        var tmp$ret$20 = lensPath(this_1, tmp$ret$19);
        tmp_10.vir_1 = assertNotBlank(tmp$ret$20);
        var tmp_12 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_2 = this.tir_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_13 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$21 = isInterface(tmp_13, KSerializer()) ? tmp_13 : THROW_CCE();
        var it_1 = new (DataClassPathSelf())(tmp$ret$21);
        var tmp$ret$23 = get_contactEmail(it_1);
        var tmp$ret$24 = lensPath(this_2, tmp$ret$23);
        tmp_12.wir_1 = assertValidEmail(tmp$ret$24);
        var tmp_14 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_3 = this.tir_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_15 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$25 = isInterface(tmp_15, KSerializer()) ? tmp_15 : THROW_CCE();
        var it_2 = new (DataClassPathSelf())(tmp$ret$25);
        var tmp$ret$27 = get_contactPhoneNumber(it_2);
        var tmp$ret$28 = lensPath(this_3, tmp$ret$27);
        tmp_14.xir_1 = assertValidPhoneNumber(tmp$ret$28);
        this.yir_1 = branch(this.kir_1);
        var tmp_16 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_4 = this.yir_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_17 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$29 = isInterface(tmp_17, KSerializer()) ? tmp_17 : THROW_CCE();
        var it_3 = new (DataClassPathSelf())(tmp$ret$29);
        var tmp$ret$31 = get_name(it_3);
        var tmp$ret$32 = lensPath(this_4, tmp$ret$31);
        tmp_16.zir_1 = assertNotBlank(tmp$ret$32);
        var tmp_18 = this;
        tmp_18.ais_1 = mutableRemember(VOID, VOID, ($this$mutableRemember) => $this$mutableRemember.daj(this.kir_1).v5i_1 === $this$mutableRemember.daj(this.kir_1).w5i_1);
        var tmp_19 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_5 = this.yir_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_20 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$33 = isInterface(tmp_20, KSerializer()) ? tmp_20 : THROW_CCE();
        var it_4 = new (DataClassPathSelf())(tmp$ret$33);
        var tmp$ret$35 = get_legalName(it_4);
        // Inline function 'kotlin.also' call
        var this_6 = lensPath(this_5, tmp$ret$35);
        assertReactive_0(this_6, 'Cannot be blank', VOID, ($this$assertReactive, it) => {
          var tmp;
          if ($this$assertReactive.daj(this.ais_1)) {
            tmp = true;
          } else {
            // Inline function 'kotlin.text.isNotBlank' call
            tmp = !isBlank(it);
          }
          return tmp;
        });
        tmp_19.bis_1 = this_6;
        var tmp_21 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_7 = this.yir_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_22 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$40 = isInterface(tmp_22, KSerializer()) ? tmp_22 : THROW_CCE();
        var it_5 = new (DataClassPathSelf())(tmp$ret$40);
        var tmp$ret$42 = get_email(it_5);
        var tmp$ret$43 = lensPath(this_7, tmp$ret$42);
        tmp_21.cis_1 = assertValidEmail(tmp$ret$43);
        var tmp_23 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_8 = this.yir_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_24 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$44 = isInterface(tmp_24, KSerializer()) ? tmp_24 : THROW_CCE();
        var it_6 = new (DataClassPathSelf())(tmp$ret$44);
        var tmp$ret$46 = get_phoneNumber(it_6);
        var tmp$ret$47 = lensPath(this_8, tmp$ret$46);
        tmp_23.dis_1 = assertValidPhoneNumber(tmp$ret$47);
        var tmp_25 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_9 = this.yir_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_26 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$48 = isInterface(tmp_26, KSerializer()) ? tmp_26 : THROW_CCE();
        var it_7 = new (DataClassPathSelf())(tmp$ret$48);
        var tmp$ret$50 = get_contactAddress(it_7);
        var tmp_27 = lensPath(this_9, tmp$ret$50);
        tmp_25.eis_1 = assert(tmp_27, 'Cannot be blank', VOID, VOID, ContractorNewRegistrationData$businessContactAddress$lambda);
        var tmp_28 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_10 = this.yir_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_29 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$52 = isInterface(tmp_29, KSerializer()) ? tmp_29 : THROW_CCE();
        var it_8 = new (DataClassPathSelf())(tmp$ret$52);
        var tmp$ret$54 = get_operationStates(it_8);
        var tmp_30 = lensPath(this_10, tmp$ret$54);
        tmp_28.fis_1 = assert(tmp_30, 'Must have at least one state', VOID, VOID, ContractorNewRegistrationData$businessStates$lambda);
        var tmp_31 = this;
        tmp_31.gis_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.daj($this$remember.daj(this.rir_1));
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.c6f_1.equals(LicenseType_Contractor_getInstance())) {
              destination.v(element);
            }
          }
          return destination;
        });
        var tmp_32 = this;
        // Inline function 'kotlin.apply' call
        var this_11 = this.yir_1.xat().vat();
        assertReactive(this_11, 'Must have at least one uploaded license', VOID, ($this$assertReactive) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$assertReactive.daj(this.gis_1).i1();
        });
        tmp_32.his_1 = this_11;
        this.iis_1 = branch(this.kir_1);
        var tmp_33 = this;
        tmp_33.jis_1 = mutableRemember(VOID, VOID, ($this$mutableRemember) => {
          var currentTrade = $this$mutableRemember.daj(this.kir_1).c5j_1;
          var tmp;
          if (!(currentTrade == null)) {
            var tmp_0;
            // Inline function 'kotlin.text.isNotEmpty' call
            if (charSequenceLength(currentTrade) > 0) {
              tmp_0 = !$this$mutableRemember.daj(this.qir_1).t1(currentTrade);
            } else {
              tmp_0 = false;
            }
            tmp = tmp_0;
          } else {
            tmp = false;
          }
          return tmp;
        });
        var tmp_34 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_12 = this.iis_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_35 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$63 = isInterface(tmp_35, KSerializer()) ? tmp_35 : THROW_CCE();
        var it_9 = new (DataClassPathSelf())(tmp$ret$63);
        var tmp$ret$65 = get_trade(it_9);
        var tmp_36 = lensPath(this_12, tmp$ret$65);
        var tmp_37 = ContractorNewRegistrationData$trade$lambda;
        var tmp_38 = tmp_36.vak(tmp_37, ContractorNewRegistrationData$trade$lambda_0);
        tmp_34.kis_1 = validate_1(tmp_38, false, ContractorNewRegistrationData$trade$lambda_1);
        var tmp_39 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_13 = this.iis_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_40 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$67 = isInterface(tmp_40, KSerializer()) ? tmp_40 : THROW_CCE();
        var it_10 = new (DataClassPathSelf())(tmp$ret$67);
        var tmp$ret$69 = get_annualRevenue(it_10);
        var tmp_41 = lensPath(this_13, tmp$ret$69);
        tmp_39.lis_1 = assert(tmp_41, 'Must be greater than 0', 'Approximate annual revenue must be greater than 0', VOID, ContractorNewRegistrationData$approxAnnualRevenue$lambda);
        var tmp_42 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_14 = this.iis_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_43 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$71 = isInterface(tmp_43, KSerializer()) ? tmp_43 : THROW_CCE();
        var it_11 = new (DataClassPathSelf())(tmp$ret$71);
        var tmp$ret$73 = get_averageJobSize(it_11);
        tmp_42.mis_1 = lensPath(this_14, tmp$ret$73);
        var tmp_44 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_15 = this.iis_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_45 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$75 = isInterface(tmp_45, KSerializer()) ? tmp_45 : THROW_CCE();
        var it_12 = new (DataClassPathSelf())(tmp$ret$75);
        var tmp$ret$77 = get_employeeCount(it_12);
        tmp_44.nis_1 = lensPath(this_15, tmp$ret$77);
        var tmp_46 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_16 = this.iis_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_47 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$79 = isInterface(tmp_47, KSerializer()) ? tmp_47 : THROW_CCE();
        var it_13 = new (DataClassPathSelf())(tmp$ret$79);
        var tmp$ret$81 = get_otherBusinessData(it_13);
        tmp_46.ois_1 = lensPath(this_16, tmp$ret$81);
        this.pis_1 = branch(this.kir_1);
        var tmp_48 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_17 = this.pis_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_49 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$83 = isInterface(tmp_49, KSerializer()) ? tmp_49 : THROW_CCE();
        var it_14 = new (DataClassPathSelf())(tmp$ret$83);
        var tmp$ret$85 = get_entityType(it_14);
        var tmp_50 = lensPath(this_17, tmp$ret$85);
        var tmp_51 = ContractorNewRegistrationData$type$lambda;
        var tmp_52 = tmp_50.vak(tmp_51, ContractorNewRegistrationData$type$lambda_0);
        tmp_48.qis_1 = assert(tmp_52, 'Must have an entityType', VOID, VOID, ContractorNewRegistrationData$type$lambda_1);
        var tmp_53 = this;
        tmp_53.ris_1 = mutableRemember(VOID, VOID, ($this$mutableRemember) => {
          var tmp0_safe_receiver = $this$mutableRemember.daj(this.mir_1);
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j88_1;
          var contact = tmp1_elvis_lhs == null ? new (Address())() : tmp1_elvis_lhs;
          return isNotBlank(contact) ? contact.equals($this$mutableRemember.daj(this.kir_1).z5i_1) : false;
        });
        var tmp_54 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_18 = this.pis_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_55 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$87 = isInterface(tmp_55, KSerializer()) ? tmp_55 : THROW_CCE();
        var it_15 = new (DataClassPathSelf())(tmp$ret$87);
        var tmp$ret$89 = get_address(it_15);
        // Inline function 'kotlin.also' call
        var this_19 = lensPath(this_18, tmp$ret$89);
        assertReactive_0(this_19, 'Cannot be blank', VOID, ($this$assertReactive, it) => $this$assertReactive.daj(this.ris_1) ? true : isNotBlank(it));
        tmp_54.sis_1 = this_19;
        var tmp_56 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_20 = this.pis_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_57 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$93 = isInterface(tmp_57, KSerializer()) ? tmp_57 : THROW_CCE();
        var it_16 = new (DataClassPathSelf())(tmp$ret$93);
        var tmp$ret$95 = get_ein(it_16);
        var tmp$ret$96 = lensPath(this_20, tmp$ret$95);
        tmp_56.tis_1 = assertNotBlankNamed(tmp$ret$96, 'EIN');
        var tmp_58 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_21 = this.pis_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_59 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$97 = isInterface(tmp_59, KSerializer()) ? tmp_59 : THROW_CCE();
        var it_17 = new (DataClassPathSelf())(tmp$ret$97);
        var tmp$ret$99 = get_stateEntityNumber(it_17);
        tmp_58.uis_1 = lensPath(this_21, tmp$ret$99);
        var tmp_60 = this;
        tmp_60.vis_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.daj($this$remember.daj(this.sir_1));
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.h5h_1.equals(Purpose_ProofOfEin_getInstance())) {
              destination.v(element);
            }
          }
          return destination;
        });
        var tmp_61 = this;
        // Inline function 'kotlin.apply' call
        var this_22 = this.pis_1.xat().vat();
        assertReactive(this_22, 'Must have at least one document', 'Must have at least one document proving federal EIN', ($this$assertReactive) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$assertReactive.daj(this.vis_1).i1();
        });
        tmp_61.wis_1 = this_22;
        var tmp_62 = this;
        tmp_62.xis_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.daj($this$remember.daj(this.sir_1));
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.h5h_1.equals(Purpose_ArticleOfIncorporation_getInstance())) {
              destination.v(element);
            }
          }
          return destination;
        });
        var tmp_63 = this;
        // Inline function 'kotlin.apply' call
        var this_23 = this.pis_1.xat().vat();
        assertReactive(this_23, 'Must have at least one document', 'Must have at least one article of incorporation / organization', ($this$assertReactive) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$assertReactive.daj(this.xis_1).i1();
        });
        tmp_63.yis_1 = this_23;
        var tmp_64 = this;
        tmp_64.zis_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.daj($this$remember.daj(this.rir_1));
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.c6f_1.equals(LicenseType_Business_getInstance())) {
              destination.v(element);
            }
          }
          return destination;
        });
        this.ait_1 = branch(this.kir_1);
        var tmp_65 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_24 = this.ait_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_66 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
        var tmp$ret$116 = isInterface(tmp_66, KSerializer()) ? tmp_66 : THROW_CCE();
        var it_18 = new (DataClassPathSelf())(tmp$ret$116);
        var tmp$ret$118 = get_owners(it_18);
        var tmp_67 = lensPath(this_24, tmp$ret$118);
        var tmp_68 = assert(tmp_67, 'You must have at least 1 owner', VOID, VOID, ContractorNewRegistrationData$owners$lambda);
        var tmp_69 = assert(tmp_68, 'At least one owner must have an uploaded document', VOID, true, ContractorNewRegistrationData$owners$lambda_0);
        tmp_65.bit_1 = assert(tmp_69, 'All owners must have a unique email', VOID, true, ContractorNewRegistrationData$owners$lambda_1);
        this.cit_1 = LateInitSignal().taq();
        var tmp_70 = this;
        tmp_70.dit_1 = new (EditSpecifications())(this.lir_1, ContractorNewRegistrationData$editSpecifications$slambda_0(this));
        this.eit_1 = setOf([RegisterAccountSection_Register_getInstance(), RegisterAccountSection_Operations_getInstance(), RegisterAccountSection_Profile_getInstance(), RegisterAccountSection_Verification_getInstance(), RegisterAccountSection_Owners_getInstance(), RegisterAccountSection_Bank_getInstance()]);
        this.fit_1 = setOf([RegisterAccountSection_Alerts_getInstance(), RegisterAccountSection_Users_getInstance(), RegisterAccountSection_Specs_getInstance()]);
        this.git_1 = plus_2(this.eit_1, this.fit_1);
        this.hit_1 = get_AppDimensions().rg2_1;
        this.iit_1 = Signal().hak(false);
      }
      yi7($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_retrievePaymentInfo__nex0l8.bind(VOID, this), $completion);
      }
      miw(writer, map) {
        // Inline function 'kotlin.with' call
        // Inline function 'com.lightningkite.kiteui.views.direct.scrolling' call
        // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
        var vertical = false;
        var horizontal = true;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
        var prev = writer.dbb_1;
        var tmp = writer;
        tmp.dbb_1 = (_this__u8e3s4) => {
          var tmp0_safe_receiver = prev;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4);
          (new (ScrollingBehaviorImpl())(_this__u8e3s4, horizontal, vertical)).qdj(false);
          return Unit_instance;
        };
        Companion_getInstance_2();
        var tmp$ret$4 = Companion_getInstance_2();
        var tmp_0 = writer.kbb(tmp$ret$4, get_compact(writer));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(writer.pc());
        var tmp0_elvis_lhs = writer.ebb_1;
        var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
        writer.gbb(p, view);
        view.zbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(false);
        view_0.bb9(get_px(0));
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = map.d2().m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          // Inline function 'kotlin.collections.component1' call
          var step = element.e2();
          var tmp_1 = sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, get_rem(6));
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (TextView())(view_0.pc());
          var tmp0_elvis_lhs_1 = view_0.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
          view_0.gbb(p_1, view_1);
          view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
          view_1.dbs(Align_Center_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var value = step.a4_1;
          var tmp_2 = view_1.vb5_1;
          var tmp_3;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(value) === 0) {
            tmp_3 = '\xA0';
          } else {
            tmp_3 = value;
          }
          tmp_2.hbu(tmp_3);
          view_0.hbb(p_1, view_1);
          view_0.lbb(tmp_1, view_1);
        }
        view.hbb(p_0, view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_2 = view.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
        view.gbb(p_2, view_2);
        view_2.zbm(false);
        view_2.bb9(get_px(0));
        var pairs = toList(map.d2());
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(pairs, 10));
        var _iterator__ex2g4s_0 = pairs.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var item = _iterator__ex2g4s_0.o1();
          var tmp$ret$19 = item.e2();
          destination.v(tmp$ret$19);
        }
        var steps = destination;
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_1 = withIndex(pairs).m1();
        while (_iterator__ex2g4s_1.n1()) {
          var element_0 = _iterator__ex2g4s_1.o1();
          var idx = element_0.cf();
          var pair = element_0.df();
          var tmp_4 = sizeConstraints(view_2, VOID, VOID, VOID, VOID, VOID, get_rem(6));
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (Frame())(view_2.pc());
          var tmp0_elvis_lhs_3 = view_2.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
          view_2.gbb(p_3, view_3);
          var tmp_5 = view_3.kbb(get_centered(view_3), sizeConstraints(view_3, VOID, VOID, VOID, VOID, VOID, get_rem(6), get_dp(4)));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (RowOrCol())(view_3.pc());
          var tmp0_elvis_lhs_4 = view_3.ebb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
          view_3.gbb(p_4, view_4);
          view_4.zbm(false);
          var tmp_6 = get_expanding(view_4);
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (Frame())(view_4.pc());
          var tmp0_elvis_lhs_5 = view_4.ebb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
          view_4.gbb(p_5, view_5);
          view_5.zb8(!(idx === 0));
          if (!(idx === 0)) {
            dynamicTheme(view_5, ContractorNewRegistrationData$renderStatusDisplay$lambda(steps, this, idx, pair));
          }
          view_4.hbb(p_5, view_5);
          view_4.lbb(tmp_6, view_5);
          var tmp_7 = get_expanding(view_4);
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_6 = new (Frame())(view_4.pc());
          var tmp0_elvis_lhs_6 = view_4.ebb_1;
          var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
          view_4.gbb(p_6, view_6);
          $l$block: {
            view_6.zb8(!(idx === pairs.p1()));
            var tmp0_elvis_lhs_7 = getOrNull(pairs, idx + 1 | 0);
            var tmp_8;
            if (tmp0_elvis_lhs_7 == null) {
              break $l$block;
            } else {
              tmp_8 = tmp0_elvis_lhs_7;
            }
            var next = tmp_8;
            if (!(idx === pairs.p1())) {
              dynamicTheme(view_6, ContractorNewRegistrationData$renderStatusDisplay$lambda_0(steps, this, idx, next));
            }
          }
          view_4.hbb(p_6, view_6);
          view_4.lbb(tmp_7, view_6);
          view_3.hbb(p_4, view_4);
          view_3.lbb(tmp_5, view_4);
          var tmp_9 = get_centered(view_3);
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_7 = new (Frame())(view_3.pc());
          var tmp0_elvis_lhs_8 = view_3.ebb_1;
          var p_7 = tmp0_elvis_lhs_8 == null ? view_3 : tmp0_elvis_lhs_8;
          view_3.gbb(p_7, view_7);
          view_7.lbb(shownWhen(view_7, true, ContractorNewRegistrationData$renderStatusDisplay$lambda_1(pair, this)), greyStatusIcon(view_7));
          view_7.lbb(shownWhen(view_7, false, ContractorNewRegistrationData$renderStatusDisplay$lambda_2(pair, this)), activeStatusIcon(view_7));
          view_7.lbb(shownWhen(view_7, false, ContractorNewRegistrationData$renderStatusDisplay$lambda_3(pair)), greenCheckIcon(view_7));
          view_3.hbb(p_7, view_7);
          view_3.lbb(tmp_9, view_7);
          view_2.hbb(p_3, view_3);
          view_2.lbb(tmp_4, view_3);
        }
        view.hbb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (Space())(view.pc(), 0.1);
        var tmp0_elvis_lhs_9 = view.ebb_1;
        var p_8 = tmp0_elvis_lhs_9 == null ? view : tmp0_elvis_lhs_9;
        view.gbb(p_8, view_8);
        view.hbb(p_8, view_8);
        writer.hbb(p, view);
        return writer.lbb(tmp_0, view);
      }
      mit(_this__u8e3s4) {
        var tmp;
        try {
          tmp = toPhoneNumber(_this__u8e3s4);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof IllegalArgumentException()) {
            var e = $p;
            tmp_0 = _PhoneNumber___init__impl__slwhzy('+');
          } else {
            throw $p;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      vit(request, onSave, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_handleSave__a0jw65.bind(VOID, this, request, onSave), $completion);
      }
      jit(request, onSave, $completion, $super) {
        request = request === VOID ? false : request;
        onSave = onSave === VOID ? null : onSave;
        return $super === VOID ? this.vit(request, onSave, $completion) : $super.vit.call(this, request, onSave, $completion);
      }
      niw(_this__u8e3s4, index, showSave, saveText, requestReview, onSave) {
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(false);
        var tmp = get_secondaryButton(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Button())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        var tmp_0 = KMutableProperty0();
        var tmp_1 = Button$_get_visible_$ref_mav0jg(view_0);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('visible', 0, tmp_0, tmp_1, Button$_set_visible_$ref_7zj5sg(view_0));
        reactiveScope(view_0, ($this$reactiveScope) => {
          var tmp$ret$0 = index > 0;
          this_0.set(tmp$ret$0);
          return Unit_instance;
        });
        specCenteredText(view_0, 'Previous');
        onClick(view_0, VOID, VOID, ContractorNewRegistrationData$navButtons$slambda_0(this, index));
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        var tmp_2 = get_expanding(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Space())(view.pc());
        var tmp0_elvis_lhs_1 = view.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.gbb(p_1, view_1);
        view.hbb(p_1, view_1);
        view.lbb(tmp_2, view_1);
        if (showSave) {
          var tmp_3 = get_primaryButton(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (Button())(view.pc());
          var tmp0_elvis_lhs_2 = view.ebb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
          view.gbb(p_2, view_2);
          specCenteredText(view_2, saveText);
          onClick(view_2, VOID, VOID, ContractorNewRegistrationData$navButtons$slambda_2(this, requestReview, onSave));
          view.hbb(p_2, view_2);
          view.lbb(tmp_3, view_2);
        } else {
          var tmp_4 = get_primaryButton(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (Button())(view.pc());
          var tmp0_elvis_lhs_3 = view.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
          view.gbb(p_3, view_3);
          specCenteredText(view_3, 'Next');
          onClick(view_3, VOID, VOID, ContractorNewRegistrationData$navButtons$slambda_4(this, requestReview, onSave, index));
          view.hbb(p_3, view_3);
          view.lbb(tmp_4, view_3);
        }
        _this__u8e3s4.hbb(p, view);
        return view;
      }
      oiw(_this__u8e3s4, index, showSave, saveText, requestReview, onSave, $super) {
        showSave = showSave === VOID ? false : showSave;
        saveText = saveText === VOID ? 'Submit' : saveText;
        requestReview = requestReview === VOID ? false : requestReview;
        onSave = onSave === VOID ? null : onSave;
        return $super === VOID ? this.niw(_this__u8e3s4, index, showSave, saveText, requestReview, onSave) : $super.niw.call(this, _this__u8e3s4, index, showSave, saveText, requestReview, onSave);
      }
      piw(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        boldSubTitle(view, 'Primary Representative');
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = get_AppDimensions().ig2_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowCollapsingToColumn())(view.pc(), listOf_0(new (Dimension())(breakpoint)));
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        var tmp = get_expanding(view_0);
        view_0.lbb(tmp, requiredField3(view_0, 'First Name', VOID, ($this$requiredField3) => {
          var tmp = validate($this$requiredField3, this.uir_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = 'John';
          view.cbs(Companion_getInstance_1().sd5_1);
          view.zah(view.icn_1, this.uir_1);
          view.obg(this.nir_1);
          $this$requiredField3.hbb(p, view);
          return $this$requiredField3.lbb(tmp, view);
        }));
        var tmp_0 = get_expanding(view_0);
        view_0.lbb(tmp_0, requiredField3(view_0, 'Last Name', VOID, ($this$requiredField3) => {
          var tmp = validate($this$requiredField3, this.vir_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = 'Smith';
          view.cbs(Companion_getInstance_1().sd5_1);
          view.zah(view.icn_1, this.vir_1);
          view.obg(this.nir_1);
          $this$requiredField3.hbb(p, view);
          return $this$requiredField3.lbb(tmp, view);
        }));
        view.hbb(p_0, view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint_0 = get_AppDimensions().ig2_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowCollapsingToColumn())(view.pc(), listOf_0(new (Dimension())(breakpoint_0)));
        var tmp0_elvis_lhs_1 = view.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.gbb(p_1, view_1);
        var tmp_1 = get_expanding(view_1);
        view_1.lbb(tmp_1, requiredField3(view_1, 'Work Email (Login)', 'Used to log into Stoze and receive notifications.', ($this$requiredField3) => {
          var tmp = validate($this$requiredField3, this.wir_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          var value = 'john@company.com';
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = value;
          view.cbs(Companion_getInstance_1().zd5_1);
          view.zah(view.icn_1, this.wir_1);
          view.obg(this.nir_1);
          $this$requiredField3.hbb(p, view);
          return $this$requiredField3.lbb(tmp, view);
        }));
        var tmp_2 = get_expanding(view_1);
        view_1.lbb(tmp_2, requiredField3(view_1, 'Cell Phone', 'Used for authentication and account alerts.', ($this$requiredField3) => {
          var tmp = validate($this$requiredField3, this.xir_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.phoneNumberInput' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (PhoneNumberInput())($this$requiredField3);
          this_0.vcl('(555) 123-4567');
          $this$requiredField3.zah(this_0.c2a(), this.xir_1);
          return $this$requiredField3.lbb(tmp, this_0);
        }));
        view.hbb(p_1, view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Space())(view.pc());
        var tmp0_elvis_lhs_2 = view.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
        view.gbb(p_2, view_2);
        view.hbb(p_2, view_2);
        body(view, 'By continuing, you confirm that you are authorized to represent this business.');
        this.oiw(view, indexOf_0(this.git_1, RegisterAccountSection_Register_getInstance()));
        _this__u8e3s4.hbb(p, view);
        return view;
      }
      qiw(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        boldSubTitle(view, 'Business Name(s)');
        requiredField3(view, 'Trade Name or DBA', 'This is the business name your clients know you by. This will be your Stoze Account name.', ($this$requiredField3) => {
          var tmp = validate($this$requiredField3, this.zir_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          var value = "John's Decks";
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = value;
          view.cbs(Companion_getInstance_1().sd5_1);
          view.zah(view.icn_1, this.zir_1);
          view.obg(this.nir_1);
          $this$requiredField3.hbb(p, view);
          return $this$requiredField3.lbb(tmp, view);
        });
        label2(view, 'Is this also the registered legal name?', 'If "No" is selected, show the field below to enter your legal name.', ($this$label2) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          view.zbm(false);
          var tmp = get_centered(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.radioButton' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RadioButton())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.zah(view_0.pc7_1, this.ais_1);
          view.hbb(p_0, view_0);
          view.lbb(tmp, view_0);
          view.lbb(get_centered(view), body(view, 'Yes'));
          var tmp_0 = get_centered(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.radioButton' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RadioButton())(view.pc());
          var tmp0_elvis_lhs_1 = view.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
          view.gbb(p_1, view_1);
          view_1.zah(view_1.pc7_1, equalTo(this.ais_1, false));
          view.hbb(p_1, view_1);
          view.lbb(tmp_0, view_1);
          view.lbb(get_centered(view), body(view, 'No'));
          $this$label2.hbb(p, view);
          return view;
        });
        var tmp = shownWhen(view, VOID, ($this$shownWhen) => !$this$shownWhen.daj(this.ais_1));
        view.lbb(tmp, requiredField3(view, 'Legal Business Name', 'Enter your registered entity name. Must match your documents and government registration.', ($this$requiredField3) => {
          var tmp = validate($this$requiredField3, this.bis_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          var value = "John's Decks LLC";
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = value;
          view.cbs(Companion_getInstance_1().sd5_1);
          view.zah(view.icn_1, this.bis_1);
          view.obg(this.nir_1);
          $this$requiredField3.hbb(p, view);
          return $this$requiredField3.lbb(tmp, view);
        }));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Space())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view.hbb(p_0, view_0);
        boldSubTitle(view, 'Business Contact');
        smallBody(view, "Tell us more about your day-to-day business operations. This helps us verify you're eligible to use Stoze and ensure compliance with state rules.");
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = get_AppDimensions().ig2_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowCollapsingToColumn())(view.pc(), listOf_0(new (Dimension())(breakpoint)));
        var tmp0_elvis_lhs_1 = view.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.gbb(p_1, view_1);
        var tmp_0 = get_expanding(view_1);
        view_1.lbb(tmp_0, requiredField3(view_1, 'Business Email', VOID, ($this$requiredField3) => {
          var tmp = validate($this$requiredField3, this.cis_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          var value = 'info@company.com';
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = value;
          view.cbs(Companion_getInstance_1().zd5_1);
          view.zah(view.icn_1, this.cis_1);
          view.obg(this.nir_1);
          $this$requiredField3.hbb(p, view);
          return $this$requiredField3.lbb(tmp, view);
        }));
        var tmp_1 = get_expanding(view_1);
        view_1.lbb(tmp_1, requiredField3(view_1, 'Business Phone', 'Primary business phone.', ($this$requiredField3) => {
          var tmp = validate($this$requiredField3, this.dis_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.phoneNumberInput' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (PhoneNumberInput())($this$requiredField3);
          this_0.vcl('(555) 123-4567');
          $this$requiredField3.zah(this_0.c2a(), this.dis_1);
          return $this$requiredField3.lbb(tmp, this_0);
        }));
        view.hbb(p_1, view_1);
        requiredLabel2(view, 'Business Address', VOID, ($this$requiredLabel2) => {
          smallBody($this$requiredLabel2, 'This is where you operate from day-to-day');
          return addressForm($this$requiredLabel2, this.eis_1);
        });
        var tmp_2 = notificationBar(view, AppColors_getInstance().lfz_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_2 = view.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
        view.gbb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_3.zbm(true);
        view_3.bb9(get_AppDimensions().rg2_1);
        body(view_3, 'You may not publish projects in unapproved states.');
        view_2.hbb(p_3, view_3);
        view.hbb(p_2, view_2);
        view.lbb(tmp_2, view_2);
        requiredField3(view, 'States Where You Operate', "We'll flag any states where escrow isn't yet supported.", ($this$requiredField3) => {
          var states = remember(VOID, VOID, VOID, ContractorNewRegistrationData$renderBusinessOpsForm$lambda$lambda);
          var tmp = validate($this$requiredField3, this.fis_1);
          var tmp0_items = this.fis_1;
          var tmp_0 = ContractorNewRegistrationData$renderBusinessOpsForm$lambda$slambda_0(states);
          var tmp_1 = ($this$multiselect, id) => {
            var tmp0 = $this$multiselect.daj(states);
            var tmp$ret$42;
            $l$block: {
              // Inline function 'kotlin.collections.first' call
              var _iterator__ex2g4s = tmp0.m1();
              while (_iterator__ex2g4s.n1()) {
                var element = _iterator__ex2g4s.o1();
                if (element.equals(id)) {
                  tmp$ret$42 = element;
                  break $l$block;
                }
              }
              throw NoSuchElementException().o('Collection contains no element matching the predicate.');
            }
            return tmp$ret$42;
          };
          var tmp_2 = ContractorNewRegistrationData$renderBusinessOpsForm$lambda$lambda_0;
          return $this$requiredField3.lbb(tmp, multiselect($this$requiredField3, tmp_0, tmp_1, tmp_2, 'Select one or multiple states', ContractorNewRegistrationData$renderBusinessOpsForm$lambda$lambda_1, VOID, tmp0_items));
        });
        requiredField3(view, 'Upload Contractor Licenses', 'Attach trade or professional licenses relevant to your work.', ($this$requiredField3) => $this$requiredField3.lbb(validate_0($this$requiredField3, this.his_1), renderLicenses($this$requiredField3, this.gis_1, LicenseType_Contractor_getInstance())));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (Space())(view.pc());
        var tmp0_elvis_lhs_4 = view.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
        view.gbb(p_4, view_4);
        view.hbb(p_4, view_4);
        this.oiw(view, indexOf_0(this.git_1, RegisterAccountSection_Operations_getInstance()));
        _this__u8e3s4.hbb(p, view);
        return view;
      }
      riw(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        boldSubTitle(view, 'Business Snapshot');
        smallBody(view, 'This helps us better understand your business scale and the types of projects you typically handle.');
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = get_AppDimensions().ig2_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowCollapsingToColumn())(view.pc(), listOf_0(new (Dimension())(breakpoint)));
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        var tmp = get_expanding(view_0);
        view_0.lbb(tmp, requiredField3(view_0, 'Trade / Industry', 'Pick what best describes your business.', ($this$requiredField3) => {
          var tmp = validate($this$requiredField3, this.kis_1, ($this$validate) => !$this$validate.daj(this.jis_1));
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Select())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          var tmp_0 = interceptWrite(this.kis_1, ContractorNewRegistrationData$renderBusinessProfileForm$lambda$slambda_0(this));
          view.ocf(tmp_0, this.qir_1, ContractorNewRegistrationData$renderBusinessProfileForm$lambda$lambda);
          $this$requiredField3.hbb(p, view);
          return $this$requiredField3.lbb(tmp, view);
        }));
        var tmp_0 = get_expanding(view_0);
        var tmp_1 = view_0.kbb(tmp_0, shownWhen(view_0, VOID, ($this$shownWhen) => $this$shownWhen.daj(this.jis_1)));
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label = 'Custom Trade';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        view_1.bb9(get_AppDimensions().pg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_2.zbm(false);
        view_2.bb9(get_AppDimensions().rg2_1);
        view_2.lbb(get_centered(view_2), bodyBold(view_2, label));
        view_2.lbb(colored(view_2, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_2, '*'));
        view_1.hbb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_2 = view_1.jbb(FieldSemantic_getInstance());
        var tmp_3 = validate(view_1, this.kis_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (TextInput())(view_1.pc());
        var tmp0_elvis_lhs_3 = view_1.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
        view_1.gbb(p_3, view_3);
        var $this$textInput = view_3;
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value = 'Enter Trade';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        $this$textInput.vb5_1.bb4_1.kb7_1.placeholder = value;
        reactive($this$textInput, ($this$reactive) => {
          var tmp;
          if ($this$reactive.daj(this.jis_1)) {
            $this$textInput.qb9();
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        $this$textInput.zah($this$textInput.icn_1, this.kis_1);
        view_1.hbb(p_3, view_3);
        var tmp$ret$13 = view_1.lbb(tmp_3, view_3);
        view_1.lbb(tmp_2, tmp$ret$13);
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_1, view_1);
        view.hbb(p_0, view_0);
        requiredField3(view, 'Approx. Annual Revenue', 'Help us tailor features to your business scale.', ($this$requiredField3) => {
          var tmp = validate($this$requiredField3, this.lis_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (NumberInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.NumberInput.hint' call
          var value = '$500,000';
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = value;
          view.cbs(Companion_getInstance_1().ud5_1);
          view.ec6(rangeTo(0.0, 1.7976931348623157E308));
          view.zah(view.zc5_1, zeroToNull(this.lis_1));
          view.obg(this.nir_1);
          $this$requiredField3.hbb(p, view);
          return $this$requiredField3.lbb(tmp, view);
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint_0 = get_AppDimensions().ig2_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowCollapsingToColumn())(view.pc(), listOf_0(new (Dimension())(breakpoint_0)));
        var tmp0_elvis_lhs_4 = view.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
        view.gbb(p_4, view_4);
        var tmp_4 = get_expanding(view_4);
        view_4.lbb(tmp_4, field3(view_4, 'Average Project Size', 'Used to estimate transaction volume.', ($this$field3) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (NumberInput())($this$field3.pc());
          var tmp0_elvis_lhs = $this$field3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$field3 : tmp0_elvis_lhs;
          $this$field3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.NumberInput.hint' call
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = '$15,000';
          view.cbs(Companion_getInstance_1().ud5_1);
          view.ec6(rangeTo(0.0, 1.7976931348623157E308));
          view.zah(view.zc5_1, zeroToNull(this.mis_1));
          view.obg(this.nir_1);
          $this$field3.hbb(p, view);
          return view;
        }));
        var tmp_5 = get_expanding(view_4);
        view_4.lbb(tmp_5, field3(view_4, 'Number of Employees', 'Include full and part-time employees.', ($this$field3) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (NumberInput())($this$field3.pc());
          var tmp0_elvis_lhs = $this$field3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$field3 : tmp0_elvis_lhs;
          $this$field3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.NumberInput.hint' call
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = '10';
          view.cbs(Companion_getInstance_1().ud5_1);
          view.ec6(rangeTo(0.0, 1.7976931348623157E308));
          view.zah(view.zc5_1, zeroToNull(this.nis_1));
          view.obg(this.nir_1);
          $this$field3.hbb(p, view);
          return view;
        }));
        view.hbb(p_4, view_4);
        field3(view, 'Additional Details (optional)', 'Any industry specialities or info you want to share.', ($this$field3) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$field3.pc());
          var tmp0_elvis_lhs = $this$field3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$field3 : tmp0_elvis_lhs;
          $this$field3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = '';
          view.cbs(Companion_getInstance_1().rd5_1);
          view.zah(view.icn_1, nullableToBlank(this.ois_1));
          view.obg(this.nir_1);
          $this$field3.hbb(p, view);
          return view;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Space())(view.pc());
        var tmp0_elvis_lhs_5 = view.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
        view.gbb(p_5, view_5);
        view.hbb(p_5, view_5);
        this.oiw(view, indexOf_0(this.git_1, RegisterAccountSection_Profile_getInstance()));
        _this__u8e3s4.hbb(p, view);
        return view;
      }
      siw(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        boldSubTitle(view, 'Business Identity');
        smallBody(view, 'We know paperwork can be a pain \u2014 but it\u2019s required to verify your business and protect your funds. Hang in there, you\u2019re almost done!');
        // Inline function 'com.crowpay.views.theming.subTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (TextView())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.lba(view_0.qb6_1.abf(SubtitleSemantic_getInstance()));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(view_0);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(view_0));
        reactiveScope(view_0, ($this$reactiveScope) => {
          var tmp$ret$0 = $this$reactiveScope.daj(this.ais_1) ? $this$reactiveScope.daj(this.zir_1) : $this$reactiveScope.daj(this.bis_1);
          this_0.set(tmp$ret$0);
          return Unit_instance;
        });
        view.hbb(p_0, view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = get_AppDimensions().ig2_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowCollapsingToColumn())(view.pc(), listOf_0(new (Dimension())(breakpoint)));
        var tmp0_elvis_lhs_1 = view.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.gbb(p_1, view_1);
        var tmp_1 = get_expanding(view_1);
        view_1.lbb(tmp_1, requiredField3(view_1, 'Business Entity Type', 'Select your registered business structure.', ($this$requiredField3) => {
          var types = remember(VOID, VOID, VOID, ContractorNewRegistrationData$renderBusinessVerificationForm$lambda$lambda);
          var tmp = validate($this$requiredField3, this.qis_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Select())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          view.ocf(this.qis_1, types, ContractorNewRegistrationData$renderBusinessVerificationForm$lambda$lambda_0);
          $this$requiredField3.hbb(p, view);
          return $this$requiredField3.lbb(tmp, view);
        }));
        view.hbb(p_1, view_1);
        requiredLabel2(view, 'Registered Entity Address', VOID, ($this$requiredLabel2) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$requiredLabel2.pc());
          var tmp0_elvis_lhs = $this$requiredLabel2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredLabel2 : tmp0_elvis_lhs;
          $this$requiredLabel2.gbb(p, view);
          view.zbm(true);
          smallBody(view, 'Official business address per government registration.');
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.zbm(false);
          var tmp = get_centered(view_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (Checkbox())(view_0.pc());
          var tmp0_elvis_lhs_1 = view_0.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
          view_0.gbb(p_1, view_1);
          view_1.zah(view_1.ebk_1, this.ris_1);
          view_0.hbb(p_1, view_1);
          view_0.lbb(tmp, view_1);
          view_0.lbb(get_centered(view_0), body(view_0, 'Same As Contact Address'));
          view.hbb(p_0, view_0);
          view.lbb(shownWhen(view, VOID, ($this$shownWhen) => !$this$shownWhen.daj(this.ris_1)), addressForm(view, this.sis_1));
          $this$requiredLabel2.hbb(p, view);
          return view;
        });
        requiredField3(view, 'Federal EIN (Tax ID Number)', VOID, ($this$requiredField3) => {
          var tmp = validate($this$requiredField3, this.tis_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          var value = '12-3456789';
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = value;
          view.cbs(Companion_getInstance_1().td5_1);
          view.zah(view.icn_1, this.tis_1);
          view.obg(this.nir_1);
          $this$requiredField3.hbb(p, view);
          return $this$requiredField3.lbb(tmp, view);
        });
        requiredField3(view, 'Upload Proof of EIN', 'Accepted documents: IRS CP-575 letter, IRS 147C letter, or top page of most recent business tax return (Form 1120, 1065, or Schedule C) clearly showing EIN and legal business name', ($this$requiredField3) => $this$requiredField3.lbb(validate_0($this$requiredField3, this.wis_1), renderContractorDocuments($this$requiredField3, this.vis_1, listOf(['application/pdf', 'image/jpeg', 'image/png']), Purpose_ProofOfEin_getInstance())));
        requiredField3(view, 'Upload Articles of Inc / Org', 'Required for verification. Accepted: PDF, JPG, PNG', ($this$requiredField3) => $this$requiredField3.lbb(validate_0($this$requiredField3, this.yis_1), renderContractorDocuments($this$requiredField3, this.xis_1, listOf(['application/pdf', 'image/jpeg', 'image/png']), Purpose_ArticleOfIncorporation_getInstance())));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Space())(view.pc());
        var tmp0_elvis_lhs_2 = view.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
        view.gbb(p_2, view_2);
        view.hbb(p_2, view_2);
        boldSubTitle(view, 'Registration Numbers & Licenses');
        field3(view, 'State License Number', "Enter your state's official business license # (if applicable).", ($this$field3) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$field3.pc());
          var tmp0_elvis_lhs = $this$field3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$field3 : tmp0_elvis_lhs;
          $this$field3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = '';
          view.cbs(Companion_getInstance_1().td5_1);
          view.zah(view.icn_1, this.uis_1);
          view.obg(this.nir_1);
          $this$field3.hbb(p, view);
          return view;
        });
        field3(view, 'Upload Municipal Licenses', 'Upload city/county licenses if applicable.', ($this$field3) => renderLicenses($this$field3, this.zis_1, LicenseType_Business_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Space())(view.pc());
        var tmp0_elvis_lhs_3 = view.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
        view.gbb(p_3, view_3);
        view.hbb(p_3, view_3);
        this.oiw(view, indexOf_0(this.git_1, RegisterAccountSection_Verification_getInstance()));
        _this__u8e3s4.hbb(p, view);
        return view;
      }
      tiw(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        boldSubTitle(view, 'Owner Personal Details');
        smallBody(view, 'For compliance purposes, we need to gather a few details about the business owners. You are required to list any owner who owns at least 25%. We will automatically create users for all listed owners so they can manage this organization.');
        var tmp = get_issues(this.ait_1);
        var tmp_0 = KProperty1();
        var tmp_1 = getPropertyCallableRef('description', 1, tmp_0, Issue$_get_description_$ref_ujb3fr(), null);
        issueText(view, tmp, tmp_1, ($this$issueText) => $this$issueText.daj(this.iit_1));
        var tmp_2 = view.kbb(get_atEnd(view), get_tertiaryButton(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Button())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.gba(get_rem_0(0.3));
        view_0.bb9(get_rem_0(0.3));
        specCenteredText(view_0, '+ Add Owner');
        onClick(view_0, VOID, VOID, ContractorNewRegistrationData$renderOwnerInformationForm$slambda_0(this));
        view.hbb(p_0, view_0);
        view.lbb(tmp_2, view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_1 = view.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.gbb(p_1, view_1);
        view_1.zbm(true);
        view_1.bb9(get_rem(0));
        var tmp_3 = lens(this.bit_1, ContractorNewRegistrationData$renderOwnerInformationForm$lambda);
        forEachUpdating(view_1, tmp_3, VOID, ($this$forEachUpdating, owner) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$forEachUpdating.pc());
          var tmp0_elvis_lhs = $this$forEachUpdating.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
          $this$forEachUpdating.gbb(p, view);
          view.zbm(true);
          view.bb9(get_rem(0));
          var tmp = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(3));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.zbm(false);
          view_0.bb9(get_rem_0(0.5));
          var tmp_0 = get_expanding(view_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_1 = view_0.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
          view_0.gbb(p_1, view_1);
          view_1.zbm(false);
          view_1.bb9(get_dp(8));
          var tmp_1 = get_centered(view_1);
          // Inline function 'com.crowpay.views.theming.subTitle' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (TextView())(view_1.pc());
          var tmp0_elvis_lhs_2 = view_1.ebb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
          view_1.gbb(p_2, view_2);
          view_2.lba(view_2.qb6_1.abf(SubtitleSemantic_getInstance()));
          var tmp_2 = KMutableProperty0();
          var tmp_3 = TextView$_get_content_$ref_4pzcwl_0(view_2);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb_0(view_2));
          reactiveScope(view_2, ($this$reactiveScope) => {
            var o = $this$reactiveScope.daj(owner);
            // Inline function 'kotlin.takeUnless' call
            var this_1 = o.y6s_1;
            var tmp;
            if (!isBlank(this_1)) {
              tmp = this_1;
            } else {
              tmp = null;
            }
            var tmp0_elvis_lhs = tmp;
            var tmp$ret$5 = (tmp0_elvis_lhs == null ? 'No Title' : tmp0_elvis_lhs) + ': ' + o.t6s_1 + ' ' + o.u6s_1;
            this_0.set(tmp$ret$5);
            return Unit_instance;
          });
          view_1.hbb(p_2, view_2);
          view_1.lbb(tmp_1, view_2);
          var tmp_4 = get_centered(view_1);
          // Inline function 'com.crowpay.views.theming.smallBody' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (TextView())(view_1.pc());
          var tmp0_elvis_lhs_3 = view_1.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
          view_1.gbb(p_3, view_3);
          view_3.lba(view_3.qb6_1.abf(SmallBodySemantic_getInstance()));
          var tmp_5 = KMutableProperty0();
          var tmp_6 = TextView$_get_content_$ref_4pzcwl_1(view_3);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_1 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb_1(view_3));
          reactiveScope(view_3, ($this$reactiveScope) => {
            var tmp$ret$12 = '(' + $this$reactiveScope.daj(owner).b6t_1 + '%)';
            this_1.set(tmp$ret$12);
            return Unit_instance;
          });
          view_1.hbb(p_3, view_3);
          view_1.lbb(tmp_4, view_3);
          view_0.hbb(p_1, view_1);
          view_0.lbb(tmp_0, view_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_4 = view_0.ebb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
          view_0.gbb(p_4, view_4);
          view_4.zbm(false);
          var tmp_7 = get_centered(view_4);
          // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
          var tmp$ret$23 = view_4.jbb(ButtonSemantic_getInstance());
          var tmp_8 = view_4.kbb(tmp_7, tmp$ret$23);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (Button())(view_4.pc());
          var tmp0_elvis_lhs_5 = view_4.ebb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
          view_4.gbb(p_5, view_5);
          view_5.gba(get_rem_0(0.25));
          onClick(view_5, VOID, VOID, ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda_0(owner, this));
          view_5.lbb(get_centered(view_5), icon(view_5, resize(get_edit(Companion_getInstance_0()), get_rem_0(1.5)), 'Edit'));
          view_4.hbb(p_5, view_5);
          view_4.lbb(tmp_8, view_5);
          var tmp_9 = view_4.kbb(view_4.kbb(get_compact(view_4), get_centered(view_4)), get_deleteButton(view_4));
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_6 = new (Button())(view_4.pc());
          var tmp0_elvis_lhs_6 = view_4.ebb_1;
          var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
          view_4.gbb(p_6, view_6);
          view_6.lbb(get_centered(view_6), icon(view_6, resize(get_trash(Companion_getInstance_0()), get_rem_0(1.5)), 'Delete'));
          onClick(view_6, VOID, VOID, ContractorNewRegistrationData$renderOwnerInformationForm$lambda$slambda_2(owner, this));
          view_4.hbb(p_6, view_6);
          view_4.lbb(tmp_9, view_6);
          view_0.hbb(p_4, view_4);
          view.hbb(p_0, view_0);
          view.lbb(tmp, view_0);
          greySeparator(view);
          $this$forEachUpdating.hbb(p, view);
          return Unit_instance;
        });
        view.hbb(p_1, view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Space())(view.pc());
        var tmp0_elvis_lhs_2 = view.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
        view.gbb(p_2, view_2);
        view.hbb(p_2, view_2);
        this.oiw(view, indexOf_0(this.git_1, RegisterAccountSection_Owners_getInstance()));
        _this__u8e3s4.hbb(p, view);
        return view;
      }
      uiw(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        boldSubTitle(view, 'Bank Setup');
        label2(view, 'Connect Bank Account', 'Link your account for receiving and sending payments.', ($this$label2) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          view.zbm(true);
          validateReactive(this.kir_1, ($this$validateReactive, it) => {
            var p = $this$validateReactive.daj(this.cit_1);
            var tmp;
            var tmp_0;
            var tmp_1;
            var tmp1_safe_receiver = p == null ? null : p.b9u_1;
            if (!equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.x9u_1, OwnerStatus_Success_getInstance())) {
              tmp_1 = (p == null ? null : p.a9u_1) == null;
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              tmp_0 = true;
            } else {
              var tmp3_safe_receiver = p.a9u_1;
              tmp_0 = equals(tmp3_safe_receiver == null ? null : tmp3_safe_receiver.e9v_1, DirectStatus_Failed_getInstance());
            }
            if (tmp_0) {
              tmp = 'You have not finished connecting you bank account';
            } else {
              tmp = null;
            }
            return tmp;
          });
          var bankInfo = new (ContractorBankInfo())();
          bankInfo.xiw_1 = false;
          view.zah(this.cit_1, bankInfo.wiw_1);
          // Inline function 'kotlin.with' call
          bankInfo.ziw(view);
          $this$label2.hbb(p, view);
          return view;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Space())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view.hbb(p_0, view_0);
        var tmp = indexOf_0(this.git_1, RegisterAccountSection_Bank_getInstance());
        this.oiw(view, tmp, true, VOID, true, ContractorNewRegistrationData$renderConnectBankForm$slambda_0(view, this));
        _this__u8e3s4.hbb(p, view);
        return view;
      }
      aix(_this__u8e3s4, viewed) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        var settings = new (NotificationSubscriptionSettings())(ProjectLens_Contractor_getInstance());
        label2(view, 'Notification Preferences', VOID, ($this$label2) => {
          smallBody($this$label2, 'Choose how you want to receive Stoze updates (email, SMS, both)');
          return settings.bix($this$label2);
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Space())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view.hbb(p_0, view_0);
        var tmp = indexOf_0(this.git_1, RegisterAccountSection_Alerts_getInstance());
        this.oiw(view, tmp, VOID, VOID, VOID, ContractorNewRegistrationData$renderAlertsForm$slambda_0(settings, viewed, this));
        _this__u8e3s4.hbb(p, view);
        return view;
      }
      cix(_this__u8e3s4, viewed) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        var users = new (ManageContractorUsers())();
        label2(view, 'Add Additional Users/Admins', VOID, ($this$label2) => {
          smallBody($this$label2, 'Invite other team members to help manage your account');
          return users.dix($this$label2);
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Space())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view.hbb(p_0, view_0);
        var tmp = indexOf_0(this.git_1, RegisterAccountSection_Users_getInstance());
        this.oiw(view, tmp, VOID, VOID, VOID, ContractorNewRegistrationData$renderUserAdminForm$slambda_0(users, view, viewed, this));
        _this__u8e3s4.hbb(p, view);
        return view;
      }
      eix(_this__u8e3s4, viewed) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        label2(view, 'Additional Config Options', VOID, ($this$label2) => {
          smallBody($this$label2, 'Advanced options available in Settings after setup.');
          return render(this.dit_1, $this$label2);
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Space())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view.hbb(p_0, view_0);
        var tmp = indexOf_0(this.git_1, RegisterAccountSection_Specs_getInstance());
        this.oiw(view, tmp, true, 'Finish & Exit', VOID, ContractorNewRegistrationData$renderAccountSpecificationsForm$slambda_0(viewed, this, view));
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    initMetadataForClass($, 'ContractorNewRegistrationData', VOID, VOID, VOID, [0, 2]);
    ContractorNewRegistrationDataClass = $;
  }
  return ContractorNewRegistrationDataClass;
}
function *_generator_invoke__zhh2q8_18($this, $this$launch, $completion) {
  var tmp = $this.fix_1.yi7($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_19($this, $this$withWrite, it, $completion) {
  if (it) {
    var tmp = $this.gix_1.oir_1.iah($this.hix_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } else {
    var tmp_0 = $this.gix_1.oir_1.iah(null, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_20($this, $this$withWrite, it, $completion) {
  if (it) {
    var tmp = $this.iix_1.oir_1.iah($this.jix_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } else {
    var tmp_0 = $this.iix_1.oir_1.iah(null, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
function toIssueTracking($this, _this__u8e3s4, summary) {
  return new (ContractorNewRegistration$toIssueTracking$1())(_this__u8e3s4, summary);
}
var ContractorNewRegistration$toIssueTracking$1Class;
function ContractorNewRegistration$toIssueTracking$1() {
  if (ContractorNewRegistration$toIssueTracking$1Class === VOID) {
    class $ {
      constructor($this_toIssueTracking, $summary) {
        this.kix_1 = new (IssueNode())(null);
        this.kix_1.uat(($this$reactiveReport) => $this$reactiveReport.daj($this_toIssueTracking) ? null : new (Warning())($summary));
      }
      xat() {
        return this.kix_1;
      }
    }
    initMetadataForClass($);
    ContractorNewRegistration$toIssueTracking$1Class = $;
  }
  return ContractorNewRegistration$toIssueTracking$1Class;
}
var ContractorNewRegistration$render$slambdaClass;
function ContractorNewRegistration$render$slambda() {
  if (ContractorNewRegistration$render$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.fix_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_18.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorNewRegistration$render$slambdaClass = $;
  }
  return ContractorNewRegistration$render$slambdaClass;
}
function ContractorNewRegistration$render$slambda_0(this$0) {
  var i = new (ContractorNewRegistration$render$slambda())(this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function ContractorNewRegistration$render$lambda$lambda($next, this$0) {
  return ($this$swap) => {
    var tmp;
    if ($next) {
      tmp = mapOf([to(RegisterAccountSection_Alerts_getInstance(), toIssueTracking(this$0, this$0.miz_1, 'Alerts not viewed')), to(RegisterAccountSection_Users_getInstance(), toIssueTracking(this$0, this$0.oiz_1, 'User settings not viewed')), to(RegisterAccountSection_Specs_getInstance(), toIssueTracking(this$0, this$0.qiz_1, 'Specifications not viewed'))]);
    } else {
      var tmp_0 = to(RegisterAccountSection_Register_getInstance(), this$0.tir_1);
      var tmp_1 = to(RegisterAccountSection_Operations_getInstance(), this$0.yir_1);
      var tmp_2 = to(RegisterAccountSection_Profile_getInstance(), this$0.iis_1);
      var tmp_3 = to(RegisterAccountSection_Verification_getInstance(), this$0.pis_1);
      var tmp_4 = to(RegisterAccountSection_Owners_getInstance(), this$0.ait_1);
      var tmp_5 = RegisterAccountSection_Bank_getInstance();
      tmp = mapOf([tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, to(tmp_5, toIssueTracking(this$0, remember(VOID, VOID, VOID, ($this$remember) => {
        var p = $this$remember.daj(this$0.cit_1);
        var tmp;
        var tmp_0;
        var tmp1_safe_receiver = p == null ? null : p.b9u_1;
        if (equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.x9u_1, OwnerStatus_Success_getInstance())) {
          tmp_0 = !(p.a9u_1 == null);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          var tmp2_safe_receiver = p.a9u_1;
          tmp = !equals(tmp2_safe_receiver == null ? null : tmp2_safe_receiver.e9v_1, DirectStatus_Failed_getInstance());
        } else {
          tmp = false;
        }
        return tmp;
      }), 'Payment info not setup'))]);
    }
    var map = tmp;
    return $this$swap.lbb(get_centered($this$swap), this$0.miw($this$swap, map));
  };
}
function ContractorNewRegistration$render$lambda($regSection, this$0) {
  return ($this$remember) => $regSection.equals($this$remember.daj(this$0.oir_1));
}
var ContractorNewRegistration$render$slambdaClass_0;
function ContractorNewRegistration$render$slambda_1() {
  if (ContractorNewRegistration$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $regSection) {
        this.gix_1 = this$0;
        this.hix_1 = $regSection;
      }
      cfz($this$withWrite, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_19.bind(VOID, this, $this$withWrite, it), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.cfz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ContractorNewRegistration$render$slambdaClass_0 = $;
  }
  return ContractorNewRegistration$render$slambdaClass_0;
}
function ContractorNewRegistration$render$slambda_2(this$0, $regSection) {
  var i = new (ContractorNewRegistration$render$slambda_1())(this$0, $regSection);
  var l = ($this$withWrite, it, $completion) => i.cfz($this$withWrite, it, $completion);
  l.$arity = 2;
  return l;
}
function ContractorNewRegistration$render$lambda_0($regSection, this$0) {
  return ($this$remember) => {
    var tmp;
    switch ($regSection.b4_1) {
      case 0:
        tmp = $this$remember.daj(get_issues(this$0.tir_1)).i1();
        break;
      case 1:
        tmp = $this$remember.daj(get_issues(this$0.yir_1)).i1();
        break;
      case 2:
        tmp = $this$remember.daj(get_issues(this$0.iis_1)).i1();
        break;
      case 3:
        tmp = $this$remember.daj(get_issues(this$0.pis_1)).i1();
        break;
      case 4:
        tmp = $this$remember.daj(get_issues(this$0.ait_1)).i1();
        break;
      case 5:
        var p = $this$remember.daj(this$0.cit_1);
        var tmp_0;
        var tmp_1;
        var tmp2_safe_receiver = p == null ? null : p.b9u_1;
        if (equals(tmp2_safe_receiver == null ? null : tmp2_safe_receiver.x9u_1, OwnerStatus_Success_getInstance())) {
          tmp_1 = !(p.a9u_1 == null);
        } else {
          tmp_1 = false;
        }

        if (tmp_1) {
          var tmp3_safe_receiver = p.a9u_1;
          tmp_0 = !equals(tmp3_safe_receiver == null ? null : tmp3_safe_receiver.e9v_1, DirectStatus_Failed_getInstance());
        } else {
          tmp_0 = false;
        }

        tmp = tmp_0;
        break;
      default:
        tmp = false;
        break;
    }
    return tmp;
  };
}
function ContractorNewRegistration$render$lambda_1($isFinished, this$0, $regSection) {
  return ($this$shownWhen) => !$this$shownWhen.daj($isFinished) && !equals($this$shownWhen.daj(this$0.oir_1), $regSection);
}
function ContractorNewRegistration$render$lambda_2($isFinished, this$0, $regSection) {
  return ($this$shownWhen) => !$this$shownWhen.daj($isFinished) && equals($this$shownWhen.daj(this$0.oir_1), $regSection);
}
function ContractorNewRegistration$render$lambda_3($isFinished) {
  return ($this$shownWhen) => $this$shownWhen.daj($isFinished);
}
function ContractorNewRegistration$render$lambda_4($index, $regSection) {
  return ($this$leftExpandButton) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$leftExpandButton.pc());
    var tmp0_elvis_lhs = $this$leftExpandButton.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$leftExpandButton : tmp0_elvis_lhs;
    $this$leftExpandButton.gbb(p, view);
    view.zbm(false);
    view.bb9(get_rem(0));
    body(view, 'STEP ' + ($index + 1 | 0) + ' ');
    bodyBold(view, $regSection.tiz_1);
    $this$leftExpandButton.hbb(p, view);
    return Unit_instance;
  };
}
function ContractorNewRegistration$render$lambda_5($thisExpand) {
  return ($this$shownWhen) => $this$shownWhen.daj($thisExpand);
}
function ContractorNewRegistration$render$lambda_6($regSection, this$0) {
  return ($this$remember) => $regSection.equals($this$remember.daj(this$0.oir_1));
}
var ContractorNewRegistration$render$slambdaClass_1;
function ContractorNewRegistration$render$slambda_3() {
  if (ContractorNewRegistration$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0, $regSection) {
        this.iix_1 = this$0;
        this.jix_1 = $regSection;
      }
      cfz($this$withWrite, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_20.bind(VOID, this, $this$withWrite, it), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.cfz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ContractorNewRegistration$render$slambdaClass_1 = $;
  }
  return ContractorNewRegistration$render$slambdaClass_1;
}
function ContractorNewRegistration$render$slambda_4(this$0, $regSection) {
  var i = new (ContractorNewRegistration$render$slambda_3())(this$0, $regSection);
  var l = ($this$withWrite, it, $completion) => i.cfz($this$withWrite, it, $completion);
  l.$arity = 2;
  return l;
}
function ContractorNewRegistration$render$lambda_7($regSection, this$0) {
  return ($this$remember) => {
    switch ($regSection.b4_1) {
      case 6:
        return $this$remember.daj(this$0.miz_1);
      case 7:
        return $this$remember.daj(this$0.oiz_1);
      case 8:
        return $this$remember.daj(this$0.qiz_1);
      default:
        return false;
    }
  };
}
function ContractorNewRegistration$render$lambda_8($isFinished, this$0, $regSection) {
  return ($this$shownWhen) => !$this$shownWhen.daj($isFinished) && !equals($this$shownWhen.daj(this$0.oir_1), $regSection);
}
function ContractorNewRegistration$render$lambda_9($isFinished, this$0, $regSection) {
  return ($this$shownWhen) => !$this$shownWhen.daj($isFinished) && equals($this$shownWhen.daj(this$0.oir_1), $regSection);
}
function ContractorNewRegistration$render$lambda_10($isFinished) {
  return ($this$shownWhen) => $this$shownWhen.daj($isFinished);
}
function ContractorNewRegistration$render$lambda_11($index, $regSection) {
  return ($this$leftExpandButton) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$leftExpandButton.pc());
    var tmp0_elvis_lhs = $this$leftExpandButton.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$leftExpandButton : tmp0_elvis_lhs;
    $this$leftExpandButton.gbb(p, view);
    view.zbm(false);
    view.bb9(get_rem(0));
    body(view, 'STEP ' + ($index + 1 | 0) + ' ');
    bodyBold(view, $regSection.tiz_1);
    $this$leftExpandButton.hbb(p, view);
    return Unit_instance;
  };
}
function ContractorNewRegistration$render$lambda_12($thisExpand) {
  return ($this$shownWhen) => $this$shownWhen.daj($thisExpand);
}
var ContractorNewRegistrationClass;
function ContractorNewRegistration() {
  if (ContractorNewRegistrationClass === VOID) {
    class $ extends ContractorNewRegistrationData() {
      constructor() {
        super();
        this.kiz_1 = new (Constant())(_Constant___init__impl__v45mub('Register'));
        var tmp = this;
        var tmp0 = 'alert-settings-viewed';
        // Inline function 'com.lightningkite.kiteui.reactive.PersistentProperty' call
        var defaultValue = emptySet();
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_0 = serializer(createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), false));
        var tmp$ret$1 = isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
        tmp.liz_1 = PersistentProperty().qd8(tmp0, defaultValue, tmp$ret$1);
        var tmp_0 = this;
        tmp_0.miz_1 = lens_0(this.liz_1, (it) => it.t1(this.lir_1));
        var tmp_1 = this;
        var tmp0_0 = 'user-settings-viewed';
        // Inline function 'com.lightningkite.kiteui.reactive.PersistentProperty' call
        var defaultValue_0 = emptySet();
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_1 = serializer(createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), false));
        var tmp$ret$4 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
        tmp_1.niz_1 = PersistentProperty().qd8(tmp0_0, defaultValue_0, tmp$ret$4);
        var tmp_2 = this;
        tmp_2.oiz_1 = lens_0(this.niz_1, (it) => it.t1(this.lir_1));
        var tmp_3 = this;
        var tmp0_1 = 'spec-settings-viewed';
        // Inline function 'com.lightningkite.kiteui.reactive.PersistentProperty' call
        var defaultValue_1 = emptySet();
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), false));
        var tmp$ret$7 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        tmp_3.piz_1 = PersistentProperty().qd8(tmp0_1, defaultValue_1, tmp$ret$7);
        var tmp_4 = this;
        tmp_4.qiz_1 = lens_0(this.piz_1, (it) => it.t1(this.lir_1));
      }
      wcv() {
        return this.kiz_1;
      }
      wd6(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        launch(view, VOID, VOID, ContractorNewRegistration$render$slambda_0(this));
        var tmp_0 = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (SwapView())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        var this_0 = view_1;
        var queue = ArrayList().w();
        var alreadySwapping = {_v: false};
        reactiveScope(this_0, ($this$reactiveScope) => {
          var c = contains(this.fit_1, $this$reactiveScope.daj(this.oir_1));
          queue.v(c);
          var tmp;
          if (alreadySwapping._v) {
            return Unit_instance;
          }
          alreadySwapping._v = true;
          $l$loop: while (true) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!!queue.i1()) {
              break $l$loop;
            }
            var next = queue.z3(0);
            try {
              var tmp_0 = Companion_getInstance_3().xax_1;
              this_0.tci(tmp_0, ContractorNewRegistration$render$lambda$lambda(next, this));
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                report(Exception().vd('Failed to render ' + toString(next), e), 'SwapView.swapping');
              } else {
                throw $p;
              }
            }
          }
          alreadySwapping._v = false;
          return Unit_instance;
        });
        view_0.hbb(p_1, view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = get_AppDimensions().ig2_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowCollapsingToColumn())(view_0.pc(), listOf_0(new (Dimension())(breakpoint)));
        var tmp0_elvis_lhs_2 = view_0.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.gbb(p_2, view_2);
        view_2.lbb(get_centered(view_2), title(view_2, 'Register Account'));
        var tmp_1 = get_centered(view_2);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content = '(Must be submitted within 7 days)';
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (TextView())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_3.lba(view_3.qb6_1.abf(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_2 = view_3.vb5_1;
        var tmp_3;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content) === 0) {
          tmp_3 = '\xA0';
        } else {
          tmp_3 = content;
        }
        tmp_2.hbu(tmp_3);
        view_2.hbb(p_3, view_3);
        view_2.lbb(tmp_1, view_3);
        view_0.hbb(p_2, view_2);
        // Inline function 'kotlin.collections.forEachIndexed' call
        var index = 0;
        var _iterator__ex2g4s = this.git_1.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          var tmp0 = checkIndexOverflow(_unary__edvuaz);
          $l$block: {
            if (this.fit_1.t1(item)) {
              break $l$block;
            }
            var tmp_4 = remember(VOID, VOID, VOID, ContractorNewRegistration$render$lambda(item, this));
            var thisExpand = withWrite(tmp_4, ContractorNewRegistration$render$slambda_2(this, item));
            // Inline function 'com.lightningkite.kiteui.views.direct.col' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_4 = new (RowOrCol())(view_0.pc());
            var tmp0_elvis_lhs_4 = view_0.ebb_1;
            var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
            view_0.gbb(p_4, view_4);
            view_4.zbm(true);
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_5 = new (RowOrCol())(view_4.pc());
            var tmp0_elvis_lhs_5 = view_4.ebb_1;
            var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
            view_4.gbb(p_5, view_5);
            view_5.zbm(false);
            view_5.bb9(this.hit_1);
            var tmp_5 = get_centered(view_5);
            // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_6 = new (Frame())(view_5.pc());
            var tmp0_elvis_lhs_6 = view_5.ebb_1;
            var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
            view_5.gbb(p_6, view_6);
            view_6.gba(get_dp(3));
            var isFinished = remember(VOID, VOID, VOID, ContractorNewRegistration$render$lambda_0(item, this));
            view_6.lbb(shownWhen(view_6, true, ContractorNewRegistration$render$lambda_1(isFinished, this, item)), greyStatusIcon(view_6));
            view_6.lbb(shownWhen(view_6, false, ContractorNewRegistration$render$lambda_2(isFinished, this, item)), activeStatusIcon(view_6));
            view_6.lbb(shownWhen(view_6, false, ContractorNewRegistration$render$lambda_3(isFinished)), greenCheckIcon(view_6));
            view_5.hbb(p_6, view_6);
            view_5.lbb(tmp_5, view_6);
            var tmp_6 = view_5.kbb(get_section(view_5), get_expanding(view_5));
            view_5.lbb(tmp_6, leftExpandButton(view_5, thisExpand, VOID, VOID, VOID, VOID, ContractorNewRegistration$render$lambda_4(tmp0, item)));
            view_4.hbb(p_5, view_5);
            var tmp_7 = shownWhen(view_4, false, ContractorNewRegistration$render$lambda_5(thisExpand));
            // Inline function 'com.crowpay.views.components.indentIfWideCol' call
            var indent = Indent_Section_getInstance();
            var tmp_8;
            if (get_viewIsWide(view_4)) {
              // Inline function 'com.crowpay.views.components.indentedCol' call
              var tmp2 = indent.agr_1;
              // Inline function 'com.crowpay.views.components.indentedCol' call
              var afterSpace = indent.bgr_1;
              var tmp_9 = get_unpadded(view_4);
              // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_7 = new (Frame())(view_4.pc());
              var tmp0_elvis_lhs_7 = view_4.ebb_1;
              var p_7 = tmp0_elvis_lhs_7 == null ? view_4 : tmp0_elvis_lhs_7;
              view_4.gbb(p_7, view_7);
              var tmp_10;
              var tmp_11 = null;
              if (!((tmp_11 == null ? null : new (Dimension())(tmp_11)) == null)) {
                tmp_10 = sizeConstraints(view_7, VOID, VOID, VOID, VOID, VOID, null);
              } else {
                tmp_10 = Companion_getInstance_2();
              }
              var tmp_12 = view_7.kbb(tmp_10, indented(view_7, tmp2, afterSpace));
              // Inline function 'com.lightningkite.kiteui.views.direct.col' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_8 = new (RowOrCol())(view_7.pc());
              var tmp0_elvis_lhs_8 = view_7.ebb_1;
              var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
              view_7.gbb(p_8, view_8);
              view_8.zbm(true);
              switch (item.b4_1) {
                case 0:
                  this.piw(view_8);
                  break;
                case 1:
                  this.qiw(view_8);
                  break;
                case 2:
                  this.riw(view_8);
                  break;
                case 3:
                  this.siw(view_8);
                  break;
                case 4:
                  this.tiw(view_8);
                  break;
                case 5:
                  this.uiw(view_8);
                  break;
                default:
                  null;
                  break;
              }
              view_7.hbb(p_8, view_8);
              view_7.lbb(tmp_12, view_8);
              view_4.hbb(p_7, view_7);
              tmp_8 = view_4.lbb(tmp_9, view_7);
            } else {
              // Inline function 'com.lightningkite.kiteui.views.direct.col' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_9 = new (RowOrCol())(view_4.pc());
              var tmp0_elvis_lhs_9 = view_4.ebb_1;
              var p_9 = tmp0_elvis_lhs_9 == null ? view_4 : tmp0_elvis_lhs_9;
              view_4.gbb(p_9, view_9);
              view_9.zbm(true);
              switch (item.b4_1) {
                case 0:
                  this.piw(view_9);
                  break;
                case 1:
                  this.qiw(view_9);
                  break;
                case 2:
                  this.riw(view_9);
                  break;
                case 3:
                  this.siw(view_9);
                  break;
                case 4:
                  this.tiw(view_9);
                  break;
                case 5:
                  this.uiw(view_9);
                  break;
                default:
                  null;
                  break;
              }
              view_4.hbb(p_9, view_9);
              tmp_8 = view_9;
            }
            var tmp$ret$37 = tmp_8;
            view_4.lbb(tmp_7, tmp$ret$37);
            view_0.hbb(p_4, view_4);
          }
        }
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (Space())(view_0.pc());
        var tmp0_elvis_lhs_10 = view_0.ebb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_0 : tmp0_elvis_lhs_10;
        view_0.gbb(p_10, view_10);
        view_0.hbb(p_10, view_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_11 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_11 = view_0.ebb_1;
        var p_11 = tmp0_elvis_lhs_11 == null ? view_0 : tmp0_elvis_lhs_11;
        view_0.gbb(p_11, view_11);
        view_11.zbm(false);
        view_11.lbb(get_centered(view_11), title(view_11, 'Account Setup'));
        view_0.hbb(p_11, view_11);
        // Inline function 'kotlin.collections.forEachIndexed' call
        var index_0 = 0;
        var _iterator__ex2g4s_0 = this.git_1.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var item_0 = _iterator__ex2g4s_0.o1();
          var _unary__edvuaz_0 = index_0;
          index_0 = _unary__edvuaz_0 + 1 | 0;
          var tmp0_0 = checkIndexOverflow(_unary__edvuaz_0);
          $l$block_0: {
            if (this.eit_1.t1(item_0)) {
              break $l$block_0;
            }
            var tmp_13 = remember(VOID, VOID, VOID, ContractorNewRegistration$render$lambda_6(item_0, this));
            var thisExpand_0 = withWrite(tmp_13, ContractorNewRegistration$render$slambda_4(this, item_0));
            // Inline function 'com.lightningkite.kiteui.views.direct.col' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_12 = new (RowOrCol())(view_0.pc());
            var tmp0_elvis_lhs_12 = view_0.ebb_1;
            var p_12 = tmp0_elvis_lhs_12 == null ? view_0 : tmp0_elvis_lhs_12;
            view_0.gbb(p_12, view_12);
            view_12.zbm(true);
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_13 = new (RowOrCol())(view_12.pc());
            var tmp0_elvis_lhs_13 = view_12.ebb_1;
            var p_13 = tmp0_elvis_lhs_13 == null ? view_12 : tmp0_elvis_lhs_13;
            view_12.gbb(p_13, view_13);
            view_13.zbm(false);
            view_13.bb9(this.hit_1);
            var isFinished_0 = remember(VOID, VOID, VOID, ContractorNewRegistration$render$lambda_7(item_0, this));
            var tmp_14 = get_centered(view_13);
            // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_14 = new (Frame())(view_13.pc());
            var tmp0_elvis_lhs_14 = view_13.ebb_1;
            var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
            view_13.gbb(p_14, view_14);
            view_14.gba(get_dp(3));
            view_14.lbb(shownWhen(view_14, true, ContractorNewRegistration$render$lambda_8(isFinished_0, this, item_0)), greyStatusIcon(view_14));
            view_14.lbb(shownWhen(view_14, false, ContractorNewRegistration$render$lambda_9(isFinished_0, this, item_0)), activeStatusIcon(view_14));
            view_14.lbb(shownWhen(view_14, false, ContractorNewRegistration$render$lambda_10(isFinished_0)), greenCheckIcon(view_14));
            view_13.hbb(p_14, view_14);
            view_13.lbb(tmp_14, view_14);
            var tmp_15 = view_13.kbb(get_section(view_13), get_expanding(view_13));
            view_13.lbb(tmp_15, leftExpandButton(view_13, thisExpand_0, VOID, VOID, VOID, VOID, ContractorNewRegistration$render$lambda_11(tmp0_0, item_0)));
            view_12.hbb(p_13, view_13);
            var tmp_16 = shownWhen(view_12, false, ContractorNewRegistration$render$lambda_12(thisExpand_0));
            // Inline function 'com.crowpay.views.components.indentIfWideCol' call
            var indent_0 = Indent_Section_getInstance();
            var tmp_17;
            if (get_viewIsWide(view_12)) {
              // Inline function 'com.crowpay.views.components.indentedCol' call
              var tmp2_0 = indent_0.agr_1;
              // Inline function 'com.crowpay.views.components.indentedCol' call
              var afterSpace_0 = indent_0.bgr_1;
              var tmp_18 = get_unpadded(view_12);
              // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_15 = new (Frame())(view_12.pc());
              var tmp0_elvis_lhs_15 = view_12.ebb_1;
              var p_15 = tmp0_elvis_lhs_15 == null ? view_12 : tmp0_elvis_lhs_15;
              view_12.gbb(p_15, view_15);
              var tmp_19;
              var tmp_20 = null;
              if (!((tmp_20 == null ? null : new (Dimension())(tmp_20)) == null)) {
                tmp_19 = sizeConstraints(view_15, VOID, VOID, VOID, VOID, VOID, null);
              } else {
                tmp_19 = Companion_getInstance_2();
              }
              var tmp_21 = view_15.kbb(tmp_19, indented(view_15, tmp2_0, afterSpace_0));
              // Inline function 'com.lightningkite.kiteui.views.direct.col' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_16 = new (RowOrCol())(view_15.pc());
              var tmp0_elvis_lhs_16 = view_15.ebb_1;
              var p_16 = tmp0_elvis_lhs_16 == null ? view_15 : tmp0_elvis_lhs_16;
              view_15.gbb(p_16, view_16);
              view_16.zbm(true);
              switch (item_0.b4_1) {
                case 6:
                  this.aix(view_16, this.liz_1);
                  break;
                case 7:
                  this.cix(view_16, this.niz_1);
                  break;
                case 8:
                  this.eix(view_16, this.piz_1);
                  break;
                default:
                  null;
                  break;
              }
              view_15.hbb(p_16, view_16);
              view_15.lbb(tmp_21, view_16);
              view_12.hbb(p_15, view_15);
              tmp_17 = view_12.lbb(tmp_18, view_15);
            } else {
              // Inline function 'com.lightningkite.kiteui.views.direct.col' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_17 = new (RowOrCol())(view_12.pc());
              var tmp0_elvis_lhs_17 = view_12.ebb_1;
              var p_17 = tmp0_elvis_lhs_17 == null ? view_12 : tmp0_elvis_lhs_17;
              view_12.gbb(p_17, view_17);
              view_17.zbm(true);
              switch (item_0.b4_1) {
                case 6:
                  this.aix(view_17, this.liz_1);
                  break;
                case 7:
                  this.cix(view_17, this.niz_1);
                  break;
                case 8:
                  this.eix(view_17, this.piz_1);
                  break;
                default:
                  null;
                  break;
              }
              view_12.hbb(p_17, view_17);
              tmp_17 = view_17;
            }
            var tmp$ret$71 = tmp_17;
            view_12.lbb(tmp_16, tmp$ret$71);
            view_0.hbb(p_12, view_12);
          }
        }
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
    }
    initMetadataForClass($, 'ContractorNewRegistration', ContractorNewRegistration, VOID, [Page(), ContractorNewRegistrationData()], [0, 2]);
    ContractorNewRegistrationClass = $;
  }
  return ContractorNewRegistrationClass;
}
function statusTheming(_this__u8e3s4, theme, color) {
  var tmp0_background = Companion_getInstance_4().taz_1;
  var tmp1_outlineWidth = get_dp(3);
  var tmp2_cornerRadii = new (ForceConstant())(get_rem(1));
  var tmp3_padding = Edges().cd0(get_rem_0(0.1));
  return _this__u8e3s4.jd1(theme, VOID, VOID, VOID, tmp2_cornerRadii, VOID, tmp3_padding, VOID, color, color, tmp1_outlineWidth, VOID, tmp0_background);
}
var CompletedSemanticClass;
function CompletedSemantic() {
  if (CompletedSemanticClass === VOID) {
    class $ extends Semantic() {
      static viz() {
        CompletedSemantic_instance = null;
        var $this = this.dd1('cmpltd');
        CompletedSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var color = AppColors_getInstance().ffz_1.zg9_1;
        var tmp = CardSemantic_getInstance();
        var tmp_0 = to(tmp, ($this$to, it) => statusTheming($this$to, it, color));
        var tmp_1 = InsetSemantic_getInstance();
        return this.gd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf([tmp_0, to(tmp_1, ($this$to, it) => $this$to.md1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, color).bb1_1)]));
      }
      toString() {
        return 'CompletedSemantic';
      }
      hashCode() {
        return -1388144004;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CompletedSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'CompletedSemantic');
    CompletedSemanticClass = $;
  }
  return CompletedSemanticClass;
}
var CompletedSemantic_instance;
function CompletedSemantic_getInstance() {
  if (CompletedSemantic_instance === VOID)
    CompletedSemantic().viz();
  return CompletedSemantic_instance;
}
var InProgressSemanticClass;
function InProgressSemantic() {
  if (InProgressSemanticClass === VOID) {
    class $ extends Semantic() {
      static xiz() {
        InProgressSemantic_instance = null;
        var $this = this.dd1('inprgs');
        InProgressSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var color = AppColors_getInstance().efz_1.zg9_1;
        var tmp = CardSemantic_getInstance();
        var tmp_0 = to(tmp, ($this$to, it) => statusTheming($this$to, it, color));
        var tmp_1 = InsetSemantic_getInstance();
        return this.gd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf([tmp_0, to(tmp_1, ($this$to, it) => $this$to.md1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, color).bb1_1)]));
      }
      toString() {
        return 'InProgressSemantic';
      }
      hashCode() {
        return -690759059;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof InProgressSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'InProgressSemantic');
    InProgressSemanticClass = $;
  }
  return InProgressSemanticClass;
}
var InProgressSemantic_instance;
function InProgressSemantic_getInstance() {
  if (InProgressSemantic_instance === VOID)
    InProgressSemantic().xiz();
  return InProgressSemantic_instance;
}
var UnstartedSemanticClass;
function UnstartedSemantic() {
  if (UnstartedSemanticClass === VOID) {
    class $ extends Semantic() {
      static ziz() {
        UnstartedSemantic_instance = null;
        var $this = this.dd1('unstrtd');
        UnstartedSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var color = AppColors_getInstance().hfz_1.zg9_1;
        var tmp = CardSemantic_getInstance();
        var tmp_0 = to(tmp, ($this$to, it) => statusTheming($this$to, it, color));
        var tmp_1 = InsetSemantic_getInstance();
        return this.gd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf([tmp_0, to(tmp_1, ($this$to, it) => $this$to.md1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, color).bb1_1)]));
      }
      toString() {
        return 'UnstartedSemantic';
      }
      hashCode() {
        return 1050811129;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UnstartedSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'UnstartedSemantic');
    UnstartedSemanticClass = $;
  }
  return UnstartedSemanticClass;
}
var UnstartedSemantic_instance;
function UnstartedSemantic_getInstance() {
  if (UnstartedSemantic_instance === VOID)
    UnstartedSemantic().ziz();
  return UnstartedSemantic_instance;
}
function greenCheckIcon(_this__u8e3s4) {
  var tmp = _this__u8e3s4.kbb(get_centered(_this__u8e3s4), _this__u8e3s4.jbb(CompletedSemantic_getInstance().abf(CardSemantic_getInstance())));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  icon(view, resize(Companion_getInstance_0().xcf_1, get_rem_0(1.25)), 'Completed');
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
function activeStatusIcon(_this__u8e3s4) {
  var tmp = _this__u8e3s4.kbb(get_centered(_this__u8e3s4), _this__u8e3s4.jbb(InProgressSemantic_getInstance().abf(CardSemantic_getInstance())));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  icon(view, resize(Companion_getInstance_0().pcf_1, get_rem_0(1.25)), 'In Progress');
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
function greyStatusIcon(_this__u8e3s4) {
  var tmp = _this__u8e3s4.kbb(get_centered(_this__u8e3s4), _this__u8e3s4.jbb(UnstartedSemantic_getInstance().abf(CardSemantic_getInstance())));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  icon(view, resize(get_empty(Companion_getInstance_0()), get_rem_0(1.25)), 'Unstarted');
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
//region block: exports
export {
  ContractorNewRegistration as ContractorNewRegistration1u860bdbb1seh,
};
//endregion

//# sourceMappingURL=NewContractorRegistration.mjs.map
